import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { OdaAtFirestore } from 'src/app/models/odaAtFirestore.model';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { environment } from 'src/environments/environment';
import { onSnapshot } from 'firebase/firestore';
import { UtilService } from 'src/app/services/util.service';
import { Menu } from 'primeng/menu';

import { ExcelService } from 'src/app/services/excelService.service';
import { FiltroPratica, PraticaFlowdy2_Firestore } from 'src/app/models/praticaFirestore.model';
import { StiliService } from 'src/app/services/stili.service';
import { UserService } from 'src/app/services/user.service';
import { deleteObject, getBlob, getStorage, listAll, ref } from 'firebase/storage';
import { saveAs } from "file-saver";
import { PraticheService } from 'src/app/services/pratiche.service';
import { DialogNoteReworkFase1 } from '../../shared/note-rework-fase1/note-rework.component';
import * as JSZip from 'jszip';
import { ComunicaBocciatura } from '../../shared/comunica-bocciatura/comunica_bocciatura.component';
import { DialogAccettazioneInvioInfratel } from '../../shared/comunica-accettazione/accettazione.component';
import { Location } from "@angular/common";
import { Utente } from 'src/app/models/utente.model';
import { OdaService } from 'src/app/services/oda.service';
import { ListeService } from 'src/app/services/liste.service';
import { StoricoPraticaComponent } from '../../shared/storico/storico-pratica.component';
import { DialogComunicaDataAppuntamentoFase2 } from '../../shared/data-appuntamento-fase2/data_appuntamento_fase2.component';
import { DialogComunicaEsitoAppuntamentoFase2 } from '../../shared/esito-appuntamento-fase2/esito_appuntamento_fase2.component';
import { DialogCaricaFoto } from '../../shared/carica-foto/carica-foto.component';
import { DialogNoteReworkFase2 } from '../../shared/note-rework-fase2/note-rework.component';
import { DialogInvioInfratel } from '../../shared/comunica-invio-infratel/invio-infratel.component';
import { DialogCaricaPermessoFase2 } from '../../shared/carica-permesso/carica-permesso_fase2.component';
import { v4 as uuidv4 } from 'uuid';
import { ImportLog_Firestore } from 'src/app/models/firestore/importLogFirestore.model';
import { DialogPresidioTIMRifiutaPratica } from '../../shared/presidioTIM-rifiuta-pratica/presidioTIM_rifiuta_pratica.component';
import { PosizioneScuola } from '../../shared/posizione-scuola/posizione-scuola.component';
import { PraticaScuola } from 'src/app/models/pratica.scuola.model';
import { ScuolaDTO } from 'src/app/models/scuola.model';
import { ScuoleService } from 'src/app/services/scuole.service';
import { ModificaPratica } from '../../shared/modifica-pratica/modifica-pratica.component';
import { DialogModificaStatoPraticaBando1 } from '../../../scuola/bando1/pratiche-scuola-bando1.component';
import { DialogInformazioniFase3Bando1 } from './inserisci-info/inserisci-info-fase3.component';
import { DialogCaricaPacchettoNT9 } from '../../shared/carica-NT9/carica-nt9.component';
import { DialogCaricaAltriFile } from '../../shared/carica-altri-file/carica-altri-file.component';
import { DialogVerificaConsegnaFase3 } from '../../shared/verifica-consegna-fase3/verifica_consegna_fase3.component';
import { ModificaCodiceinvio } from '../../shared/modifica-codice-invio/modifica-codice_invio.component';
import { CompletaFase3 } from './completa-pratica/completa_fase3_pratica.component';
import { DialogCaricaVerbaleFase3Firmato } from '../../shared/carica-verbale-fase3/carica-verbale_fase3.component';
import { GoogleStorageService } from 'src/app/services/googleStorage.service';
import { DialogCaricaPacchettoFirmatoFase3 } from '../../shared/carica-pacchetto-firmato-fase3/carica-pacchetto_firmato_fase3.component';
import { DialogNoteReworkFase3 } from '../../shared/note-rework-fase3/note-rework_fase3.component';
import { DialogRichiediCambioCentraleBando1 } from '../../../scuola/bando1/cambio-centrale-bando1.component';
import { Impresa } from 'src/app/models/impresa.model';
import { ImpreseService } from 'src/app/services/imprese.service';
import { StoricoNotePraticaComponent } from '../../shared/note-pratica/note-pratica.component';
import { DialogAssegnaOdaFase1 } from '../../shared/assegna-oda/assegna-oda.component';
import { DialogRichiediCambioCentraleFlowdy2 } from '../../shared/cambio-centrale/cambio-centrale-bando1.component';
import { DialogCaricaVerbaleWifiFase3 } from '../../shared/carica-verbale-wifi/carica-verbale_wifi_fase3.component';

declare const CSVBoxImporter: any;
@Component({
    templateUrl: './fase3.bando1.component.html',
    styleUrls: ['./fase3.bando1.component.css'],
    providers: [DialogService, ConfirmationService],

})
export class PraticheFase3Bando1Component implements OnInit, OnDestroy {
    protected isLoadingResults:boolean = false;
    protected mostraPraticheCompletate:boolean = false;

    private importID: string; 

    protected showIniziaProgettazione:boolean = false;
    protected showGeneraDocumentazione:boolean = false;
    protected showDeliverConfirmation:boolean = false;
    protected showAnnullaConsegnaConfirmation:boolean = false;
    protected showEliminaFileALTROConfirmation:boolean = false;
    protected showEliminaFileNT9Confirmation:boolean = false;
    protected showEliminaFileFotoRouterConfirmation:boolean = false;
    protected showEliminaFileVerbaleWifiConfirmation:boolean = false;
    protected showConfermaPreventivo:boolean = false;
    protected showResettaPratica:boolean = false;
    protected showFase1Approvata:boolean = false;
    
    public isAdmin: boolean                     = false;
    public isSuperAdmin: boolean                = false;
    public isPresidioSF: boolean                = false;
    public isPresidioTIM: boolean               = false;
    public isDirigenteFirmaVerbali: boolean     = false;
    public isDirigenteFirmaPacchetti: boolean   = false;
    public isPM:boolean                         = false;
    public isContabile:boolean                  = false;
    public isImpresa:boolean                    = false;
    public isDemo:boolean                       = false;

    protected pratiche:PraticaFlowdy2_Firestore[] ;
    protected praticheFiltrate:PraticaFlowdy2_Firestore[] ;
    protected selectedPratica:PraticaFlowdy2_Firestore ;

    protected imprese:Impresa[]=[];
    

    @ViewChild("menuAzioni", { static: true }) azioniMenu: Menu;
    @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered: Menu;

    protected menuAzioniItems!: MenuItem[];
    private _filtroPratiche!: FiltroPratica;

    get filtroPratiche(): FiltroPratica {
      return this._filtroPratiche;
    }
    
    set filtroPratiche(value: FiltroPratica) {
      this._filtroPratiche = value;
    }
    
    private collection_pratiche:string = environment.firebase.collection_pratiche;
    private collection_importLog:string = environment.firebase.collection_import_log;

    private ref: DynamicDialogRef;

    protected filterTabellaIsSet:boolean = false;
    protected filterIsSet:boolean = false;
    protected filtroInLavorazione:boolean = false;
    protected filtroLotto:String;
    protected filtroStatoInfratel:String;
    protected filtroOda:String;
    protected filtroDaPagare:boolean = false;
    protected filtroLottoPerFase:String;
    protected filtroPratica:String;
    protected filtroStatoFlowdy:String;
    protected filtroImpresa:String;
    protected ragioneSocialeImpresa:String="";
    protected filtroRegione:string = null;
    protected paginaBack:string = null;

    private csvbox_licenseKey_comunicaEsitiConsegnaFase3:string    =environment.csvBox.secret_comunicaEsitiConsegnaFase3;
    private csvbox_importer_comunicaEsitiConsegnaFase3:any;
    
    private csvbox_licenseKey_comunicaInfoFase3:string    =environment.csvBox.secret_comunicaInformazioniFase3;
    private csvbox_importer_comunicaInfoFase3:any;


    @ViewChild("praticheDT", { static: true }) praticheDT: any;
    
    constructor(
        private logger: NGXLogger,
        public firestore: AngularFirestore,
        public utilService:UtilService,
        protected stiliService:StiliService,
        private userService:UserService,
        public dialogService: DialogService,
        private messageService: MessageService,
        private confirmationService:ConfirmationService,
        // praticheService:PraticheService,
        private excelService:ExcelService,
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private odaService:OdaService,
        protected listeService:ListeService,
        private praticheService: PraticheService,
        private scuoleService: ScuoleService,
        private googleStorageService: GoogleStorageService,
        private aziendeService: ImpreseService,
        private router: Router,
    ) {
      this._filtroPratiche = {};
      this.setUserRole();
      this.loadImprese();

    }
    loadImprese() {
      this.aziendeService.getByBando("1").subscribe((aziende) => {
        this.imprese = aziende;
      });
    }

    ngOnDestroy(): void {
    }

    ngOnInit() {
      this.initCSVBox();
      this.logger.info("[FASE 3 BANDO 1] ON ONIT");
      const urlParamInLavorazione   = this.activatedRoute.snapshot.paramMap.get('lavorazione');
      const urlParamLotto           = this.activatedRoute.snapshot.paramMap.get('lotto');
      const urlParamCodiceInfratel  = this.activatedRoute.snapshot.paramMap.get('stato');
      const urlParamOda             = this.activatedRoute.snapshot.paramMap.get('oda');
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.filtroDaPagare         = params.get('da-pagare') === 'true';
        this.filtroLottoPerFase     = params.get('lotto');
        this.filtroInLavorazione    = params.get('in-lavorazione')=== 'true';
        this.filtroPratica          = params.get('pratica');
        this.filtroStatoFlowdy      = params.get('stato-flowdy');
        this.filtroImpresa          = params.get('impresa');
        this.ragioneSocialeImpresa  = params.get('ragioneSocialeImpresa');
        this.paginaBack             = params.get('from');
        this.filtroRegione          = params.get('regione');
        });
    
      if(this.filtroInLavorazione || this.filtroPratica){
        this.filterIsSet = true;
      }
      if(this.filtroStatoFlowdy){
        this.filterIsSet = true;
        this.filtroStatoFlowdy = this.filtroStatoFlowdy.toUpperCase();
      }
      if(this.filtroImpresa){
        this.filterIsSet = true;
        this.filtroImpresa = this.filtroImpresa.toUpperCase();
        this.ragioneSocialeImpresa = this.ragioneSocialeImpresa.toUpperCase();
      }

      /* if(urlParamInLavorazione){
        this.filtroInLavorazione = urlParamInLavorazione;
        this.filterIsSet = true;
      } else  */if(urlParamLotto){
        this.filtroLotto = urlParamLotto;
        this.filterIsSet = true;
      }else if(urlParamCodiceInfratel){
        this.filtroStatoInfratel = urlParamCodiceInfratel;
        this.filterIsSet = true;
      }else if(urlParamOda){
        this.filtroOda = urlParamOda;
        this.filterIsSet = true;
      }
       this.loadPratiche();
    }

    initCSVBox(){
      this.csvbox_importer_comunicaEsitiConsegnaFase3 = new CSVBoxImporter(this.csvbox_licenseKey_comunicaEsitiConsegnaFase3, {
      }, (result: boolean, data: any) => {
        if (result) {
          this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});
  
        } else {
          this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di INSERIMENTO DEGLI ESITI DELLA CONSEGNA DI FASE 3 delle pratiche del bando 1', life:10000});
        }
      });
      
      this.csvbox_importer_comunicaInfoFase3 = new CSVBoxImporter(this.csvbox_licenseKey_comunicaInfoFase3, {
        }, (result: boolean, data: any) => {
          if (result) {
            //this.messageService.add({severity:'success', summary:'', detail: data.row_success + ' pratiche bando 1 AGGIORNATE con successo!', life:10000});
            this.readImportLog();
          } else {
            this.messageService.add({severity:'info', summary:'Errore', detail:'Errore in fase di AGGIORNAMENTO DELLE INFORMAZIONI DELLA FASE 3 delle pratiche del bando 1', life:10000});
          }
        });
      
      this.csvbox_importer_comunicaEsitiConsegnaFase3.setUser({
        user_id: "default123"
      });
      this.csvbox_importer_comunicaInfoFase3.setUser({
        user_id: "default123"
      });
     
      this.csvbox_importer_comunicaEsitiConsegnaFase3.language="it";
      this.csvbox_importer_comunicaInfoFase3.language="it";
      
    
    }

    readImportLog(){
      const collectionRef = this.firestore.collection(this.collection_importLog).ref;
      let queryErrori ;
      queryErrori = collectionRef.where("id", "==", this.importID);
      this.logger.info("READ IMPORT LOG "+this.importID + " @ "+ this.collection_importLog);
      onSnapshot(queryErrori, (qs) => {
        this.isLoadingResults = false;
        this.logger.info("READ IMPORT LOG "+ qs.size);

        qs.forEach((doc) => {
            let log: ImportLog_Firestore = doc.data() as ImportLog_Firestore;
            if(!log.errori || log.errori.length == 0){
              if(!log.warning || log.warning.length == 0){
                if(log.numeroRecordNonProcessati!=0){
                  if(log.numeroRecordNonProcessati==1){
                    this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non è stata processata', life:10000});
  
                  }else {
                    this.messageService.add({severity:'success', summary:'', detail: 'Delle ' + log.numeroTotaleRecord+ ' pratiche presenti nel file ' + log.numeroRecordProcessati + ' sono state processate con successo mentre '+ log.numeroRecordNonProcessati+ ' non sono state processate', life:10000});
  
                  }
                }else{
                  this.messageService.add({severity:'success', summary:'', detail: 'Tutte le ' + log.numeroTotaleRecord+ ' pratiche presenti nel file sono state processate con successo', life:10000});
  
                }
  
              }else{
                this.messageService.add({severity:'warn', summary:'Warning', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE 1 si è concluso con '+ log.numeroRecordNonProcessati +' warning', life:10000});
              }
            }else{
              this.messageService.add({severity:'info', summary:'Errore', detail:'Il caricamento degli esiti della consegna ad INFRATEL della FASE si è concluso con '+ log.numeroRecordNonProcessati +' errori', life:10000});
            }
           
            
          });
      });
      
    }

    getTipoSedeAbbreviata(tipoSede:string):string{
      if(tipoSede.startsWith("M")){
        return "Mand. "+tipoSede.charAt(tipoSede.length-1);

      }else{
        return "Agg. "+tipoSede.charAt(tipoSede.length-1);
      }
    }

    resettaPratica(pratica:PraticaFlowdy2_Firestore){
      this.showResettaPratica = true;
      this.selectedPratica = pratica;
    }
    confermaResetPratica(){
      this.isLoadingResults = true;
      this.praticheService.resetFase3(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.showResettaPratica = false;
          this.selectedPratica = null;
          this.messageService.add({severity:'success', summary:'', detail:'FASE 3 resettata!', life:5000});
          
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di reset della FASE 3 della pratica'});
            this.isLoadingResults = false;
            this.showResettaPratica = false;
            this.selectedPratica = null;
        },
        complete: () => {
        }
      });
    }
    
    async openCaricaAzioni( event: any, pratica:PraticaFlowdy2_Firestore ): Promise<void> {
      this.selectedPratica = pratica;
      this.loadAzioni(event, pratica);
      this.azioniMenuTiered.toggle(event);
    }

    visualizzaNote(pratica: PraticaFlowdy2_Firestore) {
          this.isLoadingResults = true;
          
          this.praticheService.getNote(pratica.id).subscribe(notePratica=>{
            this.isLoadingResults = false;
            this.ref = this.dialogService.open(StoricoNotePraticaComponent, {
              data: {
                pratica: pratica,
                note: notePratica,
              },
              header: "NOTE della pratica "+pratica.cui,
              width: "50%",
              height: "85%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
          });
        }
   
    loadAzioni(event:any, pratica:PraticaFlowdy2_Firestore){
      this.menuAzioniItems = [];
      this.menuAzioniItems.push(
        {
          label: "Storico",
          icon: PrimeIcons.HISTORY,
          style: {'font-size': '12px'},
          command: () => this.openStoricoPratica(pratica),
        }
      );
        if(pratica.coordinateScuola && pratica.coordinateCentrale){
          this.menuAzioniItems.push(
            {
              label: "Posizione",
              icon: PrimeIcons.MAP_MARKER,
              style: {  'font-size':'12px'},
              command: () => this.openMappaConScuola(pratica),
            } );
        }
        
      if(this.isImpresa){ //IMPRESA

        if(pratica.statoFlowdyFase3 === 'DA ASSEGNARE' || ( pratica.statoFlowdyFase3 === "ASSEGNATA" && (!pratica.utente || pratica.utente==null )) ){
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
              icon: PrimeIcons.FILE_IMPORT,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openPrendiInCarico(pratica),
            },
          );
          
        }
        if(
          pratica.statoFlowdyFase3    !== 'CONSEGNATA' 
          && pratica.statoFlowdyFase3 !== 'IN ATTESA ODA'  
          && pratica.statoFlowdyFase3 !== 'DA ASSEGNARE' 
          && pratica.statoFlowdyFase3 !== 'IN VERIFICA SMARTFIBER' 
          && pratica.statoFlowdyFase3 !== 'IN CARICO PRESIDIO' 
          && pratica.statoFlowdyFase3 !== 'IN FIRMA VERBALE' 
          && pratica.statoFlowdyFase3 !== 'VERBALE FIRMATO' 
          && pratica.statoFlowdyFase3 !== 'FIRMATA' 
          && pratica.statoFlowdyFase3 !== 'PUBBLICATA' 
          && pratica.statoFlowdyFase3 !== 'APPROVATA'){
          this.menuAzioniItems.push(
            {
              label: "Modifica",
              icon: PrimeIcons.PENCIL,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openModificaPraticaDialog(pratica),
              disabled: this.isDemo,
              
            },
         
          );
        }
        if( pratica.statoFlowdyFase3 === 'ASSEGNATA' ){
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
              icon: PrimeIcons.FILE_IMPORT,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openPrendiInCarico(pratica),
            },
            {
              label: "Progetta",
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              icon: PrimeIcons.FILE_EDIT,
  
              command: () => this.openIniziaProgettazione(pratica),
            },
          );
           this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openRichiediModificaCentrale(pratica),
            }
          ); 
        }

        if( pratica.statoFlowdyFase3 === 'IN PROGETTAZIONE' || pratica.statoFlowdyFase3 === 'IN REWORK AZIENDA'){
         
          this.menuAzioniItems.push(
          
            {
              label: "Info Fase III",
              icon: PrimeIcons.SERVER,
              style: {  'font-size':'12px', 'font-weight': 'bold' },
              command: () => this.openInserisciDettagli(pratica),
            },
          );
           this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          ); 

          this.menuAzioniItems.push(
            {
              label: "Apri Gis2Web",
              style: {  'font-size':'12px'},
              icon: PrimeIcons.MAP_MARKER,
              command: () => this.openGis2Web(pratica),
            },
          );
          let itemsNT9:any[]          =[];
          let itemsFotoRouter:any[]   =[];
          let itemsAltro:any[]     =[];
          itemsNT9.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaFile(pratica, 'NT9'),
          });
          itemsFotoRouter.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaFile(pratica, 'FOTO ROUTER'),
          });
          itemsAltro.push({ 
            label: "Carica",
            icon: 'pi pi-upload',
            style: {  'font-size': '11px'},
            command: () => this.caricaFile(pratica, 'ALTRO'),
        });
          if(pratica.nt9Uploaded){
            itemsNT9.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'NT9'),
            },
            { 
              label: "Elimina NT9",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'NT9'),
            });
          } 
          if(pratica.fotoRouterUploaded){
            itemsFotoRouter.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'FOTO ROUTER'),
            },
            { 
              label: "Elimina Foto Router",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'FOTO ROUTER'),
            });
          } 
          if(pratica.fileAltriUploadedFase3){
            itemsAltro.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'ALTRO'),
            },
            { 
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'ALTRO'),
            });
          } 

          let itemsDocumenti:any[]=[
            {
              label: "Pacchetto NT9",
              icon: PrimeIcons.BUILDING,    
              style: {  'font-size': '11px'},
              items:  itemsNT9
            },
            {
              label: "Foto Router",
              icon: PrimeIcons.CAMERA,
              style: {  'font-size': '11px'},
              items:itemsFotoRouter
            },
            {
              label: "Altro",
              icon: PrimeIcons.FILE,
              style: {  'font-size': '11px'},
              items: itemsAltro
            }
          ];
          this.menuAzioniItems.push(
            {
               label: "Documentazione",
                icon: 'icona-documentazione',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsDocumenti
             },
           );
          
           if(this.areDocsCreatable(pratica)){
            this.menuAzioniItems.push(
              {
                label: "Genera Docs",
                icon: PrimeIcons.EYE,
                style: {  'font-weight': 'bold', 'font-size':'12px'},
                command: () => this.generaDocumentazione(pratica),
              },
            );
          }
    
           if( this.isDeliverable(pratica) || this.isInRework(pratica)){
            this.menuAzioniItems.push(
              {
                label: "Consegna",
                icon: PrimeIcons.CHECK_CIRCLE,
                style: {  'font-size':'12px','font-weight': 'bold'},
                command: () => this.consegnaPratica(pratica),
              },
            );
          } 
        }
        if(((pratica.statoFlowdyFase3 === "CONSEGNATA" && this.isImpresa) ||  pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER") ){
          this.menuAzioniItems.push(
            {
              label: "Annulla Consegna",
              icon: PrimeIcons.TIMES_CIRCLE,
              style: {   'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.annullaConsegna(pratica),
            }
            
          );
        }
        if(pratica.statoFlowdyFase3 === 'IN REWORK AZIENDA' ){
          this.menuAzioniItems.push(
          {
            label: "Note respingimento",
            icon: 'icona-note_rework',
            style: {   'font-size': '12px'},
            command: () => this.apriNoteRespingimento(pratica, false),
          });
        }
        if(pratica.statoFlowdyFase3 === 'APPROVATA' ){
          this.menuAzioniItems.push(
            { 
              label: "Scarica pacchetto",
              icon: 'pi pi-download',
              style: {   'font-size': '11px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            },);
        }

      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDemo){ //AZIONI SF & ADMIN
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
        );
        if (pratica.statoFlowdyFase3=== "DA ASSEGNARE" || (pratica.statoFlowdyFase3=== "ASSEGNATA" && (!pratica.utente || pratica.utente==null))){
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
              icon: PrimeIcons.FILE_IMPORT,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openPrendiInCarico(pratica),
            },
          );
        }
       //this.logger.info("FASE 3: LOAD AZIONI PRESIDIO SF PER PRATICA " + pratica.cui + " in stato "+ pratica.statoFlowdyFase3);
       
        if(pratica.statoFlowdyFase3 === "IN ATTESA ODA" || pratica.numeroOda === null ){
          this.menuAzioniItems.push(
            {
               label: "Assegna ODA",
                icon: 'icona-assegna-oda',
               style: {  'font-weight': 'bold', 'font-size': '12px'},
               command: () => this.assegnaODA(pratica),
               disabled: this.isDemo
             },
           );
        }
        if(pratica.statoFlowdyFase3!=='IN ATTESA ODA' 
            && pratica.statoFlowdyFase3!=='DA ASSEGNARE' 
            && pratica.statoFlowdyFase3 !== 'CONSEGNATA'
            //&& pratica.statoFlowdyFase3 !== 'IN VERIFICA SMARTFIBER' 
            && pratica.statoFlowdyFase3!=='IN CARICO PRESIDIO' 
            && pratica.statoFlowdyFase3!=='IN FIRMA VERBALE' 
            && pratica.statoFlowdyFase3!=='VERBALE FIRMATO' 
            && pratica.statoFlowdyFase3!=='FIRMATA' 
            && pratica.statoFlowdyFase3!=='PUBBLICATA' 
            && pratica.statoFlowdyFase3!=='APPROVATA'){
          this.menuAzioniItems.push(
            {
              label: "Modifica",
              icon: PrimeIcons.PENCIL,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openModificaPraticaDialog(pratica),
              disabled: this.isDemo
            },
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          );

          
        }

        if( (pratica.statoFlowdyFase3 === 'IN ATTESA ODA'       || 
          pratica.statoFlowdyFase3 === 'DA ASSEGNARE'           ||
          pratica.statoFlowdyFase3 === 'ASSEGNATA'              || 
          pratica.statoFlowdyFase3 === 'IN PROGETTAZIONE'       ||
          pratica.statoFlowdyFase3 === 'CONSEGNATA'             ||
          pratica.statoFlowdyFase3 === 'IN REWORK AZIENDA'      ||
          pratica.statoFlowdyFase3 === 'IN VERIFICA SMARTFIBER' ||
          pratica.statoFlowdyFase3 === 'IN CARICO PRESIDIO'
        ) && ((pratica.tipoSedeEffettiva && ( pratica.tipoSedeEffettiva.includes('A') || pratica.tipoSedeEffettiva.includes('B') || pratica.tipoSedeEffettiva.includes('C')) ) && !pratica.usaVecchioModelloSUBIRU) ){
            this.menuAzioniItems.push(
              {
                label: "Vecchio modello SUBIRU",
                icon: PrimeIcons.ANGLE_DOUBLE_LEFT,
                style: {  'font-weight': 'bold','font-size': '10px'},
                command: () => this.modificaModelloSUBIRU(pratica),
              }
            );
        }
       
        
        if(pratica.statoFlowdyFase3 === 'CONSEGNATA' ){
          this.menuAzioniItems.push(
            {
              label: "Prendi in carico",
              icon: PrimeIcons.FILE_IMPORT,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openPrendiInCarico(pratica),
              disabled: this.isDemo
            }
          );
        }

        if( pratica.statoFlowdyFase3 === 'ASSEGNATA'){
          this.menuAzioniItems.push(
            {
              label: "Progetta",
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              icon: PrimeIcons.FILE_EDIT,
  
              command: () => this.openIniziaProgettazione(pratica),
              disabled: this.isDemo
            },
          );
          /* this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          ); */
        }

        if( pratica.statoFlowdyFase3 === 'IN PROGETTAZIONE' || pratica.statoFlowdyFase3 === 'IN REWORK AZIENDA' || pratica.statoFlowdyFase3 === 'IN VERIFICA SMARTFIBER'){
         
          this.menuAzioniItems.push(
            {
              label: "Info Fase III",
              icon: PrimeIcons.SERVER,
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.openInserisciDettagli(pratica),
               disabled: !this.simpleCheckLavorabilitaFase3(pratica),
            },
          );
          /* this.menuAzioniItems.push(
            {
              label: "Cambio Centrale",
              icon: PrimeIcons.ENVELOPE,
              style: {  'font-size':'12px'},
              command: () => this.openRichiediModificaCentrale(pratica),
            },
          ); */

          this.menuAzioniItems.push(
            {
              label: "Apri Gis2Web",
              style: {  'font-size':'12px'},
              icon: PrimeIcons.MAP_MARKER,
              command: () => this.openGis2Web(pratica),
              disabled: this.isDemo
            },
          );
          let itemsNT9:any[]            =[];
          let itemsFotoRouter:any[]     =[];
          let itemsAltro:any[]         =[];
          let itemsVerbaleWifi:any[]   =[];

          itemsNT9.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaFile(pratica, 'NT9'),
              disabled: this.isDemo
          });
          itemsFotoRouter.push({ 
              label: "Carica",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaFile(pratica, 'FOTO ROUTER'),
              disabled: this.isDemo
          });
          itemsAltro.push({ 
            label: "Carica",
            icon: 'pi pi-upload',
            style: {  'font-size': '11px'},
            command: () => this.caricaFile(pratica, 'ALTRO'),
            disabled: this.isDemo
        });
        itemsVerbaleWifi.push({ 
          label: "Carica",
          icon: 'pi pi-upload',
          style: {  'font-size': '11px'},
          command: () => this.caricaFile(pratica, 'VERBALE WIFI'),
          disabled: this.isDemo
      });
          if(pratica.nt9Uploaded){
            itemsNT9.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              
              command: () => this.scaricaSingoloFile(pratica, 'NT9'),
            },
            { 
              label: "Elimina NT9",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '11px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'NT9'),
            });
          } 
          if(pratica.fotoRouterUploaded){
            itemsFotoRouter.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'FOTO ROUTER'),
            },
            { 
              label: "Elimina Foto Router",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '11px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'FOTO ROUTER'),
            });
          } 
          if(pratica.verbaleWifiUploaded){
            itemsVerbaleWifi.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'VERBALE WIFI'),
            },
              { 
              label: "Elimina Verbale Wifi",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'VERBALE WIFI'),
            });
          }
          if(pratica.fileAltriUploadedFase3){
            itemsAltro.push({ 
              label: "Scarica",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaSingoloFile(pratica, 'ALTRO'),
            },
            { 
              label: "Elimina tutti",
              icon: PrimeIcons.ERASER,
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.chiediEliminazioneTuttiFileCaricati(pratica, 'ALTRO'),
            }
            );
          } 

          let itemsDocumenti:any[]=[
            {
              label: "Pacchetto NT9",
              icon: PrimeIcons.BUILDING,    
              style: {  'font-size': '11px'},
              items:  itemsNT9
            },
            {
              label: "Foto Router",
              icon: PrimeIcons.CAMERA,
              style: {  'font-size': '11px'},
              items:itemsFotoRouter
            }
          ];
          /* if(pratica.wifi){
            itemsDocumenti.push({
              label: "Verbale Wifi",
              icon: PrimeIcons.WIFI,
              style: {  'font-size': '11px'},
              items:itemsVerbaleWifi
            });
          }*/
          itemsDocumenti.push({
            label: "Altro",
            icon: PrimeIcons.FILE,
            style: {  'font-size': '11px'},
            items: itemsAltro
          }); 
          this.menuAzioniItems.push(
            {
               label: "Documentazione",
                icon: 'icona-documentazione',
                style: {  'font-weight': 'bold', 'font-size': '12px'},
                items: itemsDocumenti
             },
           );
          
           if(this.areDocsCreatable(pratica)){
            this.menuAzioniItems.push(
              {
                label: "Genera Docs",
                icon: PrimeIcons.EYE,
                style: {  'font-weight': 'bold', 'font-size':'12px'},
                command: () => this.generaDocumentazione(pratica),
                disabled: this.isDemo
              },
            );
          }
    
           if( this.isDeliverable(pratica) || this.isInRework(pratica)){
            this.menuAzioniItems.push(
              {
                label: "Consegna",
                icon: PrimeIcons.CHECK_CIRCLE,
                style: {  'font-size':'12px','font-weight': 'bold'},
                command: () => this.consegnaPratica(pratica),
                disabled: this.isDemo
              },
            );
          } 
        }
        if(pratica.statoFlowdyFase3 === 'IN REWORK AZIENDA' ){
          this.menuAzioniItems.push(
          {
            label: "Note respingimento",
            icon: 'icona-note_rework',
            style: {   'font-size': '12px'},
            command: () => this.apriNoteRespingimento(pratica, false),
          });
        }

        if((pratica.statoFlowdyFase3 === "CONSEGNATA"  ||  pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER") ){
            this.menuAzioniItems.push(  
            {
              label: "Rigenera Docs",
              icon: PrimeIcons.REPLAY,
              style: {  'font-weight': 'bold','font-size': '12px'},
              command: () => this.rigeneraDocs(pratica),
            },
              {
                label: "Scarica File",
                icon: PrimeIcons.CLOUD_DOWNLOAD,
                style: {   'font-size':'12px'},
                items: [
                  {
                    label: "NT9",
                    icon: PrimeIcons.MAP,
                    styleClass: "RETstyle",
                    style: {   'font-size':'12px'},
                    command: () => this.scaricaNT9(pratica),
                  },
                  {
                    label: "RET",
                    icon: PrimeIcons.FILE_WORD,
                    styleClass: "RETstyle",
                    style: {   'font-size':'12px'},
                    command: () => this.scaricaDocs("RET", pratica),
                  },
                  {
                    label: "PSI",
                    icon: PrimeIcons.FILE_WORD,
                    styleClass: "RETstyle",
                    style: {   'font-size':'12px'},
                    command: () => this.scaricaDocs("PSI", pratica),
                  },
                  {
                    label: "ALL.IRU",
                    icon: PrimeIcons.FILE_WORD,
                    styleClass: "RETstyle",
                    style: {   'font-size':'12px'},
                    command: () => this.scaricaDocs("IRU", pratica),
                  },
                  {
                    label: "TUTTI",
                    icon: PrimeIcons.REPLAY,
                    styleClass: "RETstyle",
                    style: {   'font-size':'12px'},
                    command: () => this.scaricaDocs("ALL", pratica),
                  },
                ]
               // command: () => this.openScaricaDocumentazionePratica(pratica),
              },
            );
          
          this.menuAzioniItems.push(
            {
              label: "Annulla Consegna",
              icon: PrimeIcons.TIMES_CIRCLE,
              style: {   'font-size':'12px', 'font-weight': 'bold'},
              command: () => this.annullaConsegna(pratica),
              disabled: this.isDemo
            }
            
          );
        }
        if(pratica.statoFlowdyFase3 === "IN VERIFICA SMARTFIBER"){
          this.menuAzioniItems.push(
            {
              label: "Valida consegna",
               icon: 'icona-validazione-consegna',
              style: { 'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.validaConsegna(pratica),
              disabled: this.isDemo
            }
          );
        }

        if(    
           pratica.statoFlowdyFase3!=='IN FIRMA VERBALE' 
         // && pratica.statoFlowdyFase3!=='IN CARICO PRESIDIO' 
          && pratica.statoFlowdyFase3!=='VERBALE FIRMATO' 
          && pratica.statoFlowdyFase3!=='FIRMATA' 
         // && pratica.statoFlowdyFase3!=='PUBBLICATA' 
         // && pratica.statoFlowdyFase3!=='APPROVATA'
         ){
          this.menuAzioniItems.push(
           
            {
              label: "Resetta",
               icon: 'icona-reset',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.resettaPratica(pratica),
              disabled: this.isDemo
            },
          );
        }
         //01/09/2025: cambia stato in tutte le fasi possibili
          this.menuAzioniItems.push(
            
            {
              label: "Cambia Stato",
              icon: PrimeIcons.DIRECTIONS,
              style: {  'font-weight': 'bold','font-size': '12px'},
              command: () => this.forzaStatoPratica(pratica),
              disabled: this.isDemo
            }
          );
        
        
        
      if( pratica.statoFlowdyFase3==='IN CARICO PRESIDIO' || pratica.statoFlowdyFase3 === "APPROVATA" || pratica.statoFlowdyFase3 === "RESPINTA"){

          this.menuAzioniItems.push(
            {
              label: "Scarica pacchetto",
               icon: 'icona-scarica_pacchetto',
               style: {   'font-size': '12px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            }
          );
        }

        if(pratica.statoFlowdyFase3 === "RESPINTA" ){
          this.menuAzioniItems.push(
            /* {
              label: "Scarica pacchetto",
               icon: 'icona-scarica_pacchetto',
               style: {   'font-size': '12px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            }, */
             {
            label: "Note respingimento",
            icon: 'icona-note_rework',
            style: {   'font-size': '12px'},
            command: () => this.apriNoteRespingimento(pratica,true),
          },
          {
            label: "Prendi in carico",
            icon: 'icona-sf_in_carico',
            style: {  'font-weight': 'bold', 'font-size': '12px'},
            command: () => this.openPrendiInCarico(pratica),
            disabled: this.isDemo
          }
        
        );
      }
      

      }else if(this.isPresidioTIM){ //AZIONI PRESIDIO TIM 
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          //items:itemsNote,
          command: () => this.visualizzaNote(pratica),
          },
         );
        if(pratica.statoFlowdyFase3!=='APPROVATA' ){
          this.menuAzioniItems.push(
            {
              label: "Codice Invio",
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              icon: PrimeIcons.PENCIL,
              command: () => this.openCambiaCodiceInvio(pratica),
            },
          );
        }
        if(pratica.statoFlowdyFase3==='IN CARICO PRESIDIO' ){
           this.menuAzioniItems.push(
            {
              label: "Completa Pratica",
              style: {  'font-size':'12px', 'font-weight': 'bold'},
              icon: PrimeIcons.FILE_EDIT,
              command: () => this.openCompletaPraticaPresidioTIM(pratica),
            },
            
          /*  {
              label: "Rimanda a SmartFiber",
              style: {  'font-weight': 'bold','font-size': '12px'},
              icon: PrimeIcons.ARROW_CIRCLE_LEFT,
              command: () => this.openMandaIndietroAlPresidioSF(pratica),
            },*/
          ); 
        }

        if(pratica.statoFlowdyFase3==='IN FIRMA VERBALE' ){
          let itemsVerbale:any[]     =[];
          itemsVerbale.push(
            {
              label: "Scarica da firmare",
              icon: PrimeIcons.DOWNLOAD,
              style: {  'font-size': '11px'},
              command: () => this.scaricaVerbale(pratica, false),
            },
            { 
              label: "Carica Firmato",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaVerbaleFirmato(pratica, false),
          }); 
         
        
          this.menuAzioniItems.push(
            {
              label: "Verbale",
              icon: 'icona-verbale-fase3',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              items: itemsVerbale
            }
          );


       
        }

        if(pratica.statoFlowdyFase3==='VERBALE FIRMATO' ){
          let itemsVerbale:any[]     =[];
          
          itemsVerbale.push(
            { 
              label: "Carica nuovo",
              icon: 'pi pi-upload',
              style: {  'font-size': '11px'},
              command: () => this.caricaVerbaleFirmato(pratica, true),
            },
            { 
              label: "Scarica firmato",
              icon: 'pi pi-download',
              style: {  'font-size': '11px'},
              command: () => this.scaricaVerbaleFirmato(pratica),
            }
          ); 

          let itemsPacchetto:any[]     =[];
          itemsPacchetto.push(
            { 
              label: "Scarica da firmare",
              icon: 'pi pi-download',
              style: {   'font-size': '11px'},
              command: () => this.scaricaPacchettoPratica(pratica),
            },
            {
              label: "Carica firmato",
              icon: 'pi pi-upload',
              style: {   'font-size': '11px'},
              command: () => this.caricaPacchettoFirmato(pratica),
              
            }
          ); 

          this.menuAzioniItems.push(
            {
              label: "Verbale",
              icon: 'icona-verbale-fase3',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              items: itemsVerbale
            },
            {
              label: "Pacchetto",
              icon: 'icona-scarica_pacchetto',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              items: itemsPacchetto
            }
          );
        }
        if(pratica.statoFlowdyFase3 === "FIRMATA"){
          this.menuAzioniItems.push(
            {
              label: "Scarica Pacchetto",
              icon: 'icona-scarica_pacchetto',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.scaricaPacchettoFirmatoPratica(pratica),
            },
            {
             label: "Invio Infratel",
               icon: 'icona-invio-infratel',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              command: () => this.comunicaInvioInfratelPratica(pratica),
            }
           );
          }
          if(pratica.statoFlowdyFase3 === "PUBBLICATA"){
            this.menuAzioniItems.push(
             {
              label: "Esito",
               icon: 'icona-comunica_esito',
              style: {  'font-weight': 'bold', 'font-size': '12px'},
              items:[
                {
                  label: "Approvata",
                   icon: 'icona-approvata',
                  style: {  'font-size': '12px'},
                  command: () => this.comunicaEsitoFase3(pratica, true),
                },
                {
                  label: "Respinta",
                   icon: 'icona-respinta',
                  style: {  'font-size': '12px'},
                  command: () => this.comunicaEsitoFase3(pratica, false),
                }
              ],
            });
          }
        
      }else if(this.isDirigenteFirmaPacchetti){
        this.menuAzioniItems.push({
          label: "Note",
          icon: 'icona-note-presidio',
          style: {'font-size': '12px'},
          command: () => this.visualizzaNote(pratica),
          },
        );
      }
      
    }

    modificaModelloSUBIRU(pratica: PraticaFlowdy2_Firestore) {
      this.confirmationService.confirm({
        message: "Confermi di voler usare il modello SUBIRU PRESCORPORO per la pratica "+pratica.cui+"?",
        header: "MODELLO SUBIRU PRESCORPORO",
        icon: "pi pi-angle-double-left",
        acceptLabel: "CONFERMA",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: () => {
          this.isLoadingResults = true;
          this.praticheService.modificaModelloSUBIRU(pratica.id as number).subscribe({
            next: (v) => {},
            error: (e) => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di modifica del modello SUBIRU",
              });
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Modello SUBIRU utilizzato modificato con successo",
              });
            },
          });  
        },
        reject: () => {
          //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
        },
      });
    }

     openRichiediModificaCentrale(pratica: PraticaFlowdy2_Firestore): void {
        this.logger.info("--->  RICHIEDI CAMBIO CENTRALE DELLA PRATICA " + pratica.cui);
        
              this.ref = this.dialogService.open(DialogRichiediCambioCentraleFlowdy2, {
                data: {
                  pratica: pratica,
                 
                },
                header: "Richiesta cambio centrale per la pratica "+pratica.cui,
                width:  "65%",
                height: "35%",
                baseZIndex: 10000,
                closable: true,
                draggable: false,
              });
              this.ref.onClose.subscribe((changeRequested) => {
                if (changeRequested && changeRequested.success) {
                  this.messageService.add({
                    severity: "success",
                    summary: "Cambio Centrale" , life:10000,
                    detail: "Richiesta inviata con successo",
                  });
                }
              });
      
      }

    async scaricaPacchettoFirmatoPratica(pratica: PraticaFlowdy2_Firestore) {
        this.logger.info("---> SCARICO IL PACCHETTO FIRMATO DELLA PRATICA "+pratica.cui);
        this.isLoadingResults = true;
            const storage = getStorage();
            const pathReferenceSignedNT9Zip     = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/SIGNED/"+pratica.codiceInvio+".zip.p7m");
            const pathReferenceSignedPraticaZip = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/SIGNED/"+pratica.cui+".zip.p7m");
            const pathPacchettoFirmato = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/SIGNED/"+pratica.codiceInvio+".zip.p7m");
            let filesToDownload = [
              pathReferenceSignedNT9Zip,  
              pathReferenceSignedPraticaZip
              //pathPacchettoFirmato
              ];
              
            for (const pathRef of filesToDownload) {
              try {
                const blob = await getBlob(pathRef);
                if (blob) {
                  this.logger.info(pathRef.name); 
                  saveAs(blob, pathRef.name); 
                  this.isLoadingResults = false;
                } else {
                  this.logger.info(`Errore durante il download di ${pathRef.name}`);
                }
              }catch(error){
                this.isLoadingResults = false;
                if (error.code === 'storage/object-not-found') {
                  this.logger.info('Il file non esiste:', error.message);
                  this.messageService.add({
                    severity: "info",
                   summary: "Errore" , life:10000,
                    detail: "Il file "+ error.message+" non esiste",
                  });
                } else {
                  // Gestisci altri tipi di errori
                  this.logger.info('Errore sconosciuto:', error);
                }
              }
            }
        /* this.confirmationService.confirm({
          message: `Confermi di voler procedere con lo scaricamento del pacchetto della pratica ${pratica.cui}? L'operazione indicherà che la pratica è stata inoltrata al cliente!`,
          header: "Scarica pacchetto firmato",
          icon: "pi pi-file-import",
          acceptLabel: "CONFERMA",
          acceptButtonStyleClass: "p-button-success",
          rejectLabel: "ANNULLA",
          rejectButtonStyleClass: "p-button-warning",
          accept: async () => {
            
            },
            reject: () => {
              //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
            },
          }); */
        
      }

    caricaPacchettoFirmato(pratica: PraticaFlowdy2_Firestore): void {
        this.ref = this.dialogService.open(DialogCaricaPacchettoFirmatoFase3, {
          data: {
            pratica: pratica,
          },
          header: "Carica Pacchetto Firmato della pratica "+ pratica.cui,
          width: "70%",
          height: "55%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((uploadResult) => {
          if (uploadResult.success) {
            this.isLoadingResults = true;
            //if(!isRicarica){
              this.praticheService
              .confermaCaricamentoPacchetto(pratica.id)
              .subscribe((res) => {
                this.isLoadingResults = false;
                this.messageService.add({
                  severity: "success",
                  summary: "" , life:10000,
                  detail: "Pacchetto firmato caricato con successo",
                }); 
              });
            //} 
    
          }
        
        });
      }

    async scaricaVerbaleFirmato(pratica: PraticaFlowdy2_Firestore,) {
        this.logger.info("---> SCARICO VERBALE FIRMATO DELLA PRATICA "+pratica.cui);
        const storage = getStorage();
        
        // Primo tentativo: cerca il file con nome IRU
        const pathReferenceFileVerbaleIRU = ref(storage, "pratiche/scuola/" + pratica.cui + "/OUT/FASE3/SIGNED/Verbale_Cessione_IRU_" + pratica.codiceInvio + ".pdf.p7m");
        
        try {
          const blob = await getBlob(pathReferenceFileVerbaleIRU);
          saveAs(blob, "Verbale_Cessione_IRU_" + pratica.codiceInvio + ".pdf.p7m");
          return; // File trovato, esci dalla funzione
        } catch (error) {
          if (error.code === 'storage/object-not-found') {
            this.logger.info('File IRU non trovato, provo con SUBIRU:', error.message);
            
            // Secondo tentativo: cerca il file con nome SUBIRU
            const pathReferenceFileVerbaleSUBIRU = ref(storage, "pratiche/scuola/" + pratica.cui + "/OUT/FASE3/SIGNED/Verbale_Cessione_SUBIRU_" + pratica.codiceInvio + ".pdf.p7m");
            
            try {
              const blob = await getBlob(pathReferenceFileVerbaleSUBIRU);
              saveAs(blob, "Verbale_Cessione_SUBIRU_" + pratica.codiceInvio + ".p7m");
              return; // File trovato, esci dalla funzione
            } catch (secondError) {
              if (secondError.code === 'storage/object-not-found') {
                this.logger.info('Nessun verbale firmato trovato (né IRU né SUBIRU):', secondError.message);
                this.messageService.add({
                  severity: "info",
                  summary: "Errore", 
                  life: 10000,
                  detail: "Verbale firmato NON esistente",
                });
              } else {
                // Gestisci altri tipi di errori per il secondo tentativo
                this.logger.info('Errore sconosciuto nel secondo tentativo:', secondError);
                this.messageService.add({
                  severity: "error",
                  summary: "Errore", 
                  life: 10000,
                  detail: "Errore durante il download del verbale firmato",
                });
              }
            }
          } else {
            // Gestisci altri tipi di errori per il primo tentativo
            this.logger.info('Errore sconosciuto nel primo tentativo:', error);
            this.messageService.add({
              severity: "error",
              summary: "Errore", 
              life: 10000,
              detail: "Errore durante il download del verbale firmato",
            });
          }
        }
      }

    caricaVerbaleFirmato(pratica: PraticaFlowdy2_Firestore, isRicarica:boolean): void {
         this.ref = this.dialogService.open(DialogCaricaVerbaleFase3Firmato, {
          data: {
            pratica: pratica,
          },
          header: "Carica Verbale Firmato della Pratica "+pratica.cui,
          width:  "50%",
          height: "35%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((uploadResult) => {
          if (uploadResult.success) {
            this.isLoadingResults = true;
            //if(!isRicarica){
              this.praticheService
              .confermaCaricamentoVerbale(pratica.id)
              .subscribe((res) => {
                this.isLoadingResults = false;
                this.logger.info("AGGIORNATA PRATICA DOPO CARICAMENTO VERBALE");
                this.messageService.add({
                  severity: "success",
                  summary: "" , life:10000,
                  detail: "Verbale caricato con successo",
                }); 
              });
            //}
           
            
          }
        }); 
      }

    async scaricaVerbale(pratica: PraticaFlowdy2_Firestore, isBulk:boolean) {
        this.logger.info("---> SCARICO VERBALE DA FIRMARE DELLA PRATICA "+pratica.cui);
        if(!isBulk){
          this.logger.info("---> non bulk ");
    
          this.confirmationService.confirm({
            message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
            header: "ATTENZIONE!",
            icon: "pi pi-exclamation-circle",
            acceptLabel: "PROCEDI",
            acceptButtonStyleClass: "p-button-success",
            rejectLabel: "ANNULLA",
            rejectButtonStyleClass: "p-button-warning",
            accept: async () => {
              const storage = getStorage();
              const pathReferenceFileVerbale                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/Verbale_Cessione_IRU_"+pratica.codiceInvio+".pdf");
              try {
                const blob = await getBlob(pathReferenceFileVerbale);
                saveAs(blob, "Verbale_Cessione_SUBIRU_"+pratica.codiceInvio+".pdf");
              } catch (error) {
                if (error.code === 'storage/object-not-found') {
                  this.logger.info('Il file non esiste:', error.message);
                  this.messageService.add({
                    severity: "info",
                  summary: "Errore" , life:10000,
                    detail: "Verbale cessione IRU NON esistente",
                  });
                } else {
                  this.logger.info('Errore sconosciuto:', error);
                }
              }
              
            },
            reject: () => {
            },
          });
        }else{
          const storage = getStorage();
          const pathReferenceFileVerbale                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/Verbale_Cessione_IRU_"+pratica.codiceInvio+".pdf");
    
          try {
            const blob = await getBlob(pathReferenceFileVerbale);
            saveAs(blob, "Verbale_Cessione_IRU_"+pratica.codiceInvio+".pdf");
          } catch (error) {
            if (error.code === 'storage/object-not-found') {
              this.logger.info('Il file non esiste:', error.message);
              this.messageService.add({
                severity: "info",
              summary: "Errore" , life:10000,
                detail: "Verbale cessione IRU NON esistente",
              });
            } else {
              this.logger.info('Errore sconosciuto:', error);
            }
          }
          
        }

      }

      

    openCompletaPraticaPresidioTIM(pratica: PraticaFlowdy2_Firestore): void {
        this.logger.info("---> presidio completa la pratica");
        this.praticheService
          .getById(pratica.id.toString())
          .subscribe((praticaDaDB) => {
            this.ref = this.dialogService.open(CompletaFase3, {
              data: {
                pratica: praticaDaDB,
              },
              header: "Completamento Pratica "+pratica.cui,
              width: "55%",
              height: "50%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
            this.ref.onClose.subscribe((infoUpdated) => {
              if (infoUpdated && infoUpdated.success) {
                this.messageService.add({
                  severity: "success",
                  summary: "" , life:10000,
                  detail: "Praticha completata con successo",
                });
              }
            });
    
          });
      }

    openCambiaCodiceInvio(pratica:PraticaFlowdy2_Firestore){
        this.ref = this.dialogService.open(ModificaCodiceinvio, {
          data: {
            pratica: pratica,
            
          },
          header: "Modifica CODICE INVIO della Pratica "+pratica.cui,
          width:  "65%",
          height: "45%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((infoUpdated) => {
          if (infoUpdated && infoUpdated.success) {
            this.messageService.add({
              severity: "success",
              summary: "" , life:10000,
              detail: "CODICE INVIO modificato con successo",
            });
          }
        });
    
      }

     isDeliverable(pratica: PraticaFlowdy2_Firestore): boolean {
      if (
        pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
        pratica.fotoRouterUploaded &&
        pratica.nt9Uploaded &&
        pratica.infoCompleted
      ) {
        return true;
      }
      return false;
    }

    isInRework(pratica: PraticaFlowdy2_Firestore): boolean {
        if (pratica.statoFlowdyFase3 === "IN REWORK AZIENDA") {
          return true;
        }
        return false;
      }

      showDocs(pratica:PraticaFlowdy2_Firestore):boolean{
        if((this.isImpresa || this.isPresidioSF) && pratica.statoFlowdyFase3==='IN PROGETTAZIONE' && pratica.infoCompleted && pratica.fotoRouterUploaded){
            return true;
          }else{
           return false;        
        }
      }

    generaDocumentazione(pratica: PraticaFlowdy2_Firestore){
      this.showGeneraDocumentazione = true;
      this.selectedPratica = pratica;
    }

    confermaGenerazioneDocumentazione(){
      this.isLoadingResults = true;
      this.praticheService.generaDocsFase3(this.selectedPratica.id).subscribe({
        next: (v) => {},
        error: (e) => {
          this.isLoadingResults = false;
          this.messageService.add({
            severity: "info",
           summary: "Errore" , life:10000,
            detail: "Errore in fase di generazione dei docs della pratica",
          });
        },
        complete: () => {
          this.scaricaPreviewDocsPratica(this.selectedPratica);
          this.isLoadingResults = false;
          this.showGeneraDocumentazione = false;
          this.selectedPratica = null;

          
          
        },
      });
     
    }

    async scaricaPreviewDocsPratica(pratica: PraticaFlowdy2_Firestore) {
        this.logger.info("---> SCARICO LA PREVIEW DEI DOCS DELLA PRATICA "+pratica.cui);
        const storage = getStorage();
        const zip = new JSZip();
        const pathReferenceRET                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/"+pratica.codiceRegione+"_F_RET_01_0.docx");
        const pathReferencePSI                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/" +pratica.codiceRegione+"_F_PSI_03_0.docx");
        const pathReferenceAllegatoIRU            = ref( storage, "pratiche/scuola/" +  pratica.cui +"/OUT/FASE3/"+ pratica.cui + ".docx" );
        let filesToDownload = [
            pathReferenceRET,
            pathReferencePSI,
            pathReferenceAllegatoIRU, 
          ];
    
        const downloadPromises = [];
        for (const pathRef of filesToDownload) {
          const blob = await getBlob(pathRef);
          if (blob) {
            this.logger.info(pathRef.name);
            zip.file(pathRef.name, blob);
            
            downloadPromises.push(Promise.resolve());
          } else {
            console.error(`Errore durante il download di ${pathRef.name}`);
          }
        }
        Promise.all(downloadPromises)
        .then(() => {
          // Crea il file zip e avvia il download:
          zip.generateAsync({ type: 'blob' })
            .then((blob) => {
              saveAs(blob, pratica.cui+'.zip'); // Scarica il file zip
              this.isLoadingResults = false;
            })
            .catch(error => console.error('Errore durante la creazione dello zip:', error));
        })
        .catch(error => console.error('Errore durante il download dei file:', error));
        
      }

    areDocsCreatable(pratica: PraticaFlowdy2_Firestore): boolean {
        if (
          pratica.statoFlowdyFase3 === "IN PROGETTAZIONE" &&
          pratica.fotoRouterUploaded &&
          pratica.infoCompleted
        ) {
          return true;
        }
        return false;
      }

      showVerbaleWifiUploaded(pratica:PraticaFlowdy2_Firestore):boolean{
        if(pratica.wifi && pratica.verbaleWifiUploaded){
          return true;
        }
        return false;
      }

    async scaricaSingoloFile(pratica: PraticaFlowdy2_Firestore, tipoDocumento :string) {
      if(tipoDocumento==='NT9'){
        this.scaricaNT9FromFE(pratica);
      }else if(tipoDocumento==='FOTO ROUTER'){
        this.scaricaFotoRouter(pratica);
      
      }else if(tipoDocumento==='ALTRO'){
        this.scaricaAltriFile(pratica);
      
      }else if(tipoDocumento==='VERBALE WIFI'){
        this.scaricaVerbaleWifi(pratica);
      }
    }

    async scaricaVerbaleWifi(pratica:PraticaFlowdy2_Firestore){
      this.isLoadingResults = true;
      try {
        const storage = getStorage();
        const pathReferenceFileVerbaleWifi = ref(storage, "pratiche/scuola/" + pratica.cui +  "/IN/FASE_3/VERBALE_WIFI_"+pratica.cui+".pdf");
        const blob = await getBlob(pathReferenceFileVerbaleWifi);
        saveAs(blob, "VERBALE_WIFI_"+pratica.cui+".pdf");
      } catch (error: any) {
        let msg = "Errore durante il download del file.";
        if (error && error.code === 'storage/object-not-found') {
          msg = "File non trovato!";
        }
        this.messageService.add({
          severity: "error",
          summary: "Errore",
          detail: msg,
          life: 7000,
        });
      } finally {
        this.isLoadingResults = false;
      }
    }
    async scaricaAltriFile(pratica:PraticaFlowdy2_Firestore){
        this.isLoadingResults = true;
        const storage = getStorage();
        const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/altro/`;
        try {
          const folderRef= ref(storage, folderPath);

          const fileList = await listAll(folderRef);
          const fileNames = fileList.items.map(item => item.name); // Ottieni solo i nomi dei file
          for (const fileRef of fileNames) {
          
            const filePath = folderPath+"/"+fileRef;
            const fileReference = ref(storage, filePath);
            const blobFile = await getBlob(fileReference);
            saveAs(blobFile,fileRef);

        
          }
        

          this.isLoadingResults= false;
        } catch (error) {
          this.isLoadingResults= false;
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            detail: "Errore nel download dei file",
          });
        } 
        
      }

     openGis2Web(pratica: PraticaFlowdy2_Firestore){
        window.open("https://nt9convergo-cloud.maphosting.it/", '_blank');
        
      }

    openInserisciDettagli(praticaFromFirestore: PraticaFlowdy2_Firestore): void {
        let praticaDaAggiornare: PraticaScuola;
        let scuolaDaAggiornare: ScuolaDTO;
        
        this.praticheService
          .getById(praticaFromFirestore.id.toString())
          .subscribe((pratica) => {
            praticaDaAggiornare = pratica;
            this.scuoleService
              .getById(praticaDaAggiornare.scuola.id.toString())
              .subscribe((scuola) => {
                if(!pratica.centrale || !pratica.centrale.clli || !praticaFromFirestore.coordinateScuola){
                  this.messageService.add({
                    severity: "info",
                    summary: "Attenzione!",
                    life:10000,
                    detail: ["Impossibile inserire i dati di fase 3 della pratica "+pratica.cui+" poichè non sono presenti i dati della centrale o della scuola.", this.isImpresa ? "Contattare gli amministratori del sistema" : "Completare le informazioni tramite la funzione MODIFICA"].join('\n'),
                  });
                }else{
                  scuolaDaAggiornare = scuola;
                this.ref = this.dialogService.open(DialogInformazioniFase3Bando1, {
                  data: {
                    pratica: praticaDaAggiornare,
                    praticaFromFirestore: praticaFromFirestore,
                    scuola: scuolaDaAggiornare,
                  },
                  header: "Dettagli Pratica "+pratica.cui,
                  width:   "85%",
                  height: "85%",
                  baseZIndex: 10000,
                  closable: true,
                  draggable: false,
                });
                this.ref.onClose.subscribe((infoUpdated) => {
                  if (infoUpdated && infoUpdated.success) {
                  }
                });
                }
                
              });
          });

      }

    openIniziaProgettazione(pratica: PraticaFlowdy2_Firestore): void {
      if(!pratica.coordinateScuola){
        this.messageService.add({
          severity: "info",
          summary: "Attenzione!",
          life:10000,
          detail: "Impossibile iniziare la progettazione della pratica "+pratica.cui+" poichè non sono presenti le coordinate della scuola.",
        });
        return;
      }else{
        this.showIniziaProgettazione = true;
        this.selectedPratica = pratica;
      }
     
    }

    confermaInizioProgettazione(){
      this.isLoadingResults = true;
      this.praticheService
          .iniziaProgettazione(this.selectedPratica.id)
          .subscribe({
            next: (v) => {},
            error: (e) => {
              this.messageService.add({
                severity: "info",
               summary: "Errore" , life:10000,
                detail: "Errore in fase di inizio progettazione della pratica",
              });
              this.isLoadingResults = false;
            },
            complete: () => {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Inizio progettazione avvenuto con successo",
              });
            },
          });
      this.showIniziaProgettazione = false;
      this.selectedPratica = null;
    }

   

    
    openModificaPraticaDialog(praticaFromFirestore: PraticaFlowdy2_Firestore): void {
        let praticaDaAggiornare: PraticaScuola;
        let scuolaDaAggiornare: ScuolaDTO;
        this.praticheService
          .getById(praticaFromFirestore.id.toString())
          .subscribe((pratica) => {
            praticaDaAggiornare = pratica;
            this.logger.info(praticaDaAggiornare);
            this.scuoleService
              .getById(praticaDaAggiornare.scuola.id.toString())
              .subscribe((scuola) => {
                scuolaDaAggiornare = scuola;
                this.logger.info(scuola);
                   this.ref = this.dialogService.open(ModificaPratica, {
                  data: {
                    pratica: praticaDaAggiornare,
                    praticaFromFirestore: praticaFromFirestore,
                    scuola: scuolaDaAggiornare,
                  },
                  header: "Modifica la pratica "+pratica.cui,
                  width:  "85%",
                  height: "85%",
                  baseZIndex: 10000,
                  closable: true,
                  draggable: false,
                });
                this.ref.onClose.subscribe((infoUpdated) => {
                  if (infoUpdated && infoUpdated.success) {
                    this.messageService.add({
                      severity: "success",
                      summary: "" , life:10000,
                      detail: "Praticha modificata con successo",
                    });
                  }
                });  
              }); 
          });
        // =    praticaDaAggiornare.cui = pratica.cui;
        //    praticaDaAggiornare.id = pratica.id;
      }

      forzaStatoPratica(pratica: PraticaFlowdy2_Firestore) {
          this.ref = this.dialogService.open(DialogModificaStatoPraticaBando1, {
            data: {
              pratica: pratica,
            },
            header: "Cambio stato della Pratica "+pratica.cui,
            width: "55%",
            height: "55%",
            baseZIndex: 10000,
            closable: true,
            draggable: false,
          });
          this.ref.onClose.subscribe((statoUpdated) => {
            if (statoUpdated && statoUpdated.success) {
              this.isLoadingResults = false;
              this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "Stato della pratica "+ pratica.cui+" aggiornato con successo",
              });
            }
          });
        }

    showInfoFase3Complete(pratica:PraticaFlowdy2_Firestore):boolean{
        if((this.isImpresa || this.isPresidioSF) && pratica.statoFlowdyFase3==='IN PROGETTAZIONE' && pratica.infoCompleted ) {
          return true;
        }
        return false;
      }

    showAltriFileUploaded(pratica:PraticaFlowdy2_Firestore):boolean{
        if(
          (this.isPresidioSF) 
          && (pratica.statoFlowdyFase3==='IN PROGETTAZIONE' || pratica.statoFlowdyFase3==='CONSEGNATA' || pratica.statoFlowdyFase3==='IN VERIFICA SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK AZIENDA'  || pratica.statoFlowdyFase3==='IN CARICO PRESIDIO') 
          && pratica.fileAltriUploadedFase3){
          return true;
        }
        return false;
      }

      assegnaODA(pratica: PraticaFlowdy2_Firestore){
        const localizzazione:string =   pratica.cui.split("-")[1] === "LIG"?'LIGURIA':pratica.cui.split("-")[1] === 'PIE'?'PIEMONTE':'TOSCANA';
        this.isLoadingResults = true;
        this.odaService.getDisponibiliPerAzienda(pratica.idAziendaFase3, pratica.bando, localizzazione).subscribe( {
          next: (v) => {
            // this.logger.info(JSON.stringify(v));
            if(!v || v.length == 0){
              this.isLoadingResults = false;
              this.messageService.add({life: 10000,severity:'warn', summary:'ATTENZIONE', detail:'Nessun ODA disponibile per l\'azienda '+pratica.azienda+' ed il bando 1'});
  
            }else{
              this.isLoadingResults = false;
              this.ref = this.dialogService.open(DialogAssegnaOdaFase1, {
                data: {
                  pratica: pratica,
                  listaOda: v
                },
                header: "Assegna ODA alla pratica "+ pratica.cui.toUpperCase(),
                width: "50%",
                height: "55%",
                baseZIndex: 10000,
                closable: true,
                draggable: false,
              });
              this.ref.onClose.subscribe((confermaAssegnazioneODA) => {
                if (confermaAssegnazioneODA && confermaAssegnazioneODA.success) {
                  this.messageService.add({severity:'success', summary:'', detail:'ODA assegnato con successo!', life:3000});
                  this.loadPratiche();
                }
              });   
            }
          },
          error: (e) => {
              this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di recupero dell\'oda da assegnare alla pratica'});
              this.isLoadingResults = false;
          },
          complete: () => {
            this.isLoadingResults = false;
             
              
          }
        }); 
      }

    openMappaConScuola(pratica: PraticaFlowdy2_Firestore) {
        this.praticheService
          .getById(pratica.id.toString())
          .subscribe((praticaCompleta) => {
              this.ref = this.dialogService.open(PosizioneScuola, {
                data: {
                  pratica: pratica,
                  praticaCompleta: praticaCompleta
                },
                header: "Posizione della scuola e della centrale assegnata",
                width: "70%",
                height: "75%",
                baseZIndex: 10000,
                closable: true,
                draggable: false,
              });
        });
      }

    comunicaInvioInfratelPratica(pratica:PraticaFlowdy2_Firestore){
      
      this.ref = this.dialogService.open(DialogInvioInfratel, {
        data: {
          pratica: pratica,
          fase:3
        },
        header: "Comunicazione invio ad INFRATEL della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((invioFase1) => {
        if (invioFase1 && invioFase1.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Invio della pratica ad INFRATEL comuinicato!', life:3000});
        }
      }); 
   }
   getTooltipPenaleAttivazione(pratica:PraticaFlowdy2_Firestore){
    let messaggio:string = 'Pratica rifiutata da ';
    if (pratica.dataRispostaInfratelFase1) {
      const oggi = new Date();
      const dataRisposta = pratica.dataRispostaInfratelFase1.toDate(); // Converte il Firestore Timestamp in un oggetto Date
      const diffTime = Math.abs(oggi.getTime() - dataRisposta.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Converte il tempo in giorni
      const numeroGiorni = 90 - diffDays;
      
      if(numeroGiorni >= 0){
        messaggio += `Attenzione! Mancano ${numeroGiorni} giorni alla penale riguardante l'attivazione della scuola.`;
      }else{
        messaggio += `Attenzione! La penale riguardante l'attivazione della scuola è in corso da ${Math.abs(numeroGiorni)} giorni.`;
      }
  } else {
      messaggio += "un numero sconosciuto di giorni";
  }
    return messaggio;
   }
   checkPenaleAttivazione(pratica:PraticaFlowdy2_Firestore):boolean{
    if(pratica.codiceStatoInfratelFase1==='1-6' && pratica.statoPF ==='PRONTO' ){
        const oggi          = new Date();
        const dataPecODE    = pratica.dataPecOde.toDate(); 
        const diffTime      = Math.abs(oggi.getTime() - dataPecODE.getTime());
        const numeroGiorni  = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        if(numeroGiorni>= 60){
          return true;
        }
    }
    return false;
    
   }

   comunicaEsitoFase3(pratica:PraticaFlowdy2_Firestore, isApprovata:boolean){
    if(isApprovata){
      this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
        data: {
          pratica: pratica,
          fase:3
        },
        header: "Accettazione della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "60%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Accettazione della FASE 3 della pratica comuinicata!', life:3000});
        }
      }); 
    }else{
      this.ref = this.dialogService.open(ComunicaBocciatura, {
        data: {
          pratica: pratica,
          fase:3
        },
        header: "Indica le moditivazioni della bocciatura della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((bocciaturaFase2) => {
        if (bocciaturaFase2 && bocciaturaFase2.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Bocciatura pratica comuinicata!', life:3000});
        }
      }); 
    }
   }

   async scaricaDocs(filetype: string, pratica:PraticaFlowdy2_Firestore) {
    const storage = getStorage();
    if (filetype === "RET") {
      const pathReferenceRET = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/"+ pratica.codiceRegione + "_F_RET_01_0.docx"
      );

      const blobRET = await getBlob(pathReferenceRET);
      saveAs(blobRET, pratica.codiceRegione +"_F_RET_01_0.docx");
    } else if (filetype === "PSI") {
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
        pratica.cui +
          "/OUT/FASE3/"+ pratica.codiceRegione +"_F_PSI_03_0.docx"
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(blobPSI, pratica.codiceRegione +"_F_PSI_03_0.docx");
    } else if (filetype === "IRU") {
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" + pratica.cui +
          ".docx"
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(
        blobPSI,
        pratica.cui +".docx"
      );
    } else if (filetype === "ALL") {
      const pathReferenceRET = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/"+ pratica.codiceRegione +"_F_RET_01_0.docx"
      );
       this.googleStorageService.checkIfPraticaHasAltriFile(pratica.cui).subscribe(async risultatoCheckSuStorage =>{
        if(risultatoCheckSuStorage){
          this.openScaricaAltriFile(pratica);
        }}); 
      const blobRET = await getBlob(pathReferenceRET);
      saveAs(blobRET, pratica.codiceRegione +"_F_RET_01_0.docx");
      const pathReferencePSI = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/"+ pratica.codiceRegione +"_F_PSI_03_0.docx"
      );

      const blobPSI = await getBlob(pathReferencePSI);
      saveAs(blobPSI, pratica.codiceRegione +"_F_PSI_03_0.docx");

      const pathReferenceAllegatoIRU = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/OUT/FASE3/" + pratica.cui +".docx"
      );

      const blobAllegatoIRU = await getBlob(pathReferenceAllegatoIRU);
      saveAs(
        blobAllegatoIRU,
        pratica.cui +".docx"
      );
    }
  }

  async openScaricaAltriFile(pratica:PraticaFlowdy2_Firestore){
    const storage = getStorage();
    this.isLoadingResults = true;
    
    this.googleStorageService.checkIfPraticaHasAltriFile(pratica.cui).subscribe(async risultatoCheckSuStorage =>{
      if(risultatoCheckSuStorage){
        this.googleStorageService.downloadFolderContents(pratica.cui).subscribe(({ blob, fileName }) => {
          saveAs(blob, fileName);  
          this.isLoadingResults = false;
        }, error => {
          this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
              detail: "Errore durante lo scaricamento degli altri file caricati",
          });
          this.isLoadingResults = false;
        });
      }else{
        this.messageService.add({
          severity: "warn",
          summary: "Attenzione!" , life:10000,
          detail: "Non sono stati caricati altri file",
      });
      this.isLoadingResults = false;
      }
    });
  }

  async scaricaNT9(pratica: PraticaFlowdy2_Firestore) {
    const storage = getStorage();

    try {
      // Primo tentativo: percorso originale
      const pathReferenceNT9 = ref(
        storage,
        "pratiche/scuola/" +
          pratica.cui +
          "/IN/FASE_3/file/nt9.zip"
      );

      const blobNT9 = await getBlob(pathReferenceNT9);
      saveAs(blobNT9, "nt9.zip");
    } catch (error) {
      try {
        // Secondo tentativo: percorso alternativo richiesto
        const fallbackPathReferenceNT9 = ref(
          storage,
          "pratiche/scuola/" +
            pratica.cui +
            "/IN/FASE_3/nt9.zip"
        );

        const blobNT9 = await getBlob(fallbackPathReferenceNT9);
        saveAs(blobNT9, "nt9.zip");
      } catch (errorFallback) {
        this.messageService.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "File NT9 non trovato nei percorsi configurati",
          life: 10000,
        });
      }
    }
  }

  async rigeneraDocs(pratica: PraticaFlowdy2_Firestore) {
    this.confirmationService.confirm({
      message: `Confermi di voler RIGENERARE tutta la documentazione della pratica ${pratica.cui} ?`,
      header: "ATTENZIONE!",
      icon: "pi pi-exclamation-circle",
      acceptLabel: "PROCEDI",
      acceptButtonStyleClass: "p-button-success",
      rejectLabel: "ANNULLA",
      rejectButtonStyleClass: "p-button-warning",
      accept: async () => {
        this.praticheService.rigeneraTuttaLaDocumentazione(pratica.id.valueOf()).subscribe(risultatoRigenerazione=>{
          this.messageService.add({
            severity: "success",
            summary: "" , life:10000,
            detail: "Rigenerazione della documentazione della pratica "+pratica.cui+" completata con successo",
          });
         });
      },
      reject: () => {
      },
    });
  }

   apriNoteRespingimento(pratica:PraticaFlowdy2_Firestore, isRespigimento:boolean){
    this.ref = this.dialogService.open(DialogNoteReworkFase3, {
     data: {
       pratica: pratica,
       isRespigimento:isRespigimento,
     },
     header: "Note relative al RESPINGIMENTO della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
     width: "60%",
     height: "70%",
     baseZIndex: 10000,
     closable: true,
     draggable: false,
   }); 
 }

 simpleCheckLavorabilitaFase3(praticaFromFS:PraticaFlowdy2_Firestore):boolean{
  if(!praticaFromFS.coordinateCentrale || !praticaFromFS.coordinateScuola){
    return false;
  }
  return true;
}

 rifiutaConsegna(pratica:PraticaFlowdy2_Firestore){
     this.ref = this.dialogService.open(DialogPresidioTIMRifiutaPratica, {
       data: {
         pratica: pratica,
         fase:"3"
       },
       header: "Rifiuta la consegna della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
       width: "60%",
       height: "50%",
       baseZIndex: 10000,
       closable: true,
       draggable: false,
     });
     this.ref.onClose.subscribe((rifiutoOK) => {
       if (rifiutoOK && rifiutoOK.success) {
         this.messageService.add({severity:'success', summary:'', detail:'Consegna rifiutata !', life:3000});
       }
     }); 
 
   }
   
   async scaricaPacchettoDaStorage(pratica:PraticaFlowdy2_Firestore){
   this.isLoadingResults = true;
     const storage = getStorage();
           const zipNT9 = new JSZip();
           const zip = new JSZip();

           // Primo path NT9 (originale)
           const pathReferenceNT9_Primary = ref(
             storage,
             "pratiche/scuola/" +
               pratica.cui +
               "/IN/FASE_3/file/nt9.zip"
           );

           // Secondo path NT9 (fallback richiesto)
           const pathReferenceNT9_Fallback = ref(
             storage,
             "pratiche/scuola/" +
               pratica.cui +
               "/IN/nt9.zip"
           );

           const pathReferenceRET                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/"+pratica.codiceRegione+"_F_RET_01_0.pdf");
           const pathReferencePSI                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/"+pratica.codiceRegione+"_F_PSI_03_0.pdf");
           const pathReferenceVerbaleCessioneSUBIRU  = ref( storage, "pratiche/scuola/" +  pratica.cui +"/OUT/FASE3/SIGNED/Verbale_Cessione_SUBIRU_"+ pratica.codiceInvio + ".pdf.p7m" );
           const pathReferenceAllegatoCessioneIRU    = ref( storage, "pratiche/scuola/" +  pratica.cui +"/OUT/FASE3/" + pratica.cui + ".pdf" );
           const pathReferenceCMT                    = ref( storage, "pratiche/scuola/" + pratica.cui +  "/OUT/FASE3/"+pratica.comune.toUpperCase()+"_cmt_"+pratica.codiceInvio.toUpperCase()+".xlsx");
          
           let filesToDownload = [
               pathReferenceNT9_Primary, 
               pathReferenceRET,
               pathReferencePSI,
               pathReferenceAllegatoCessioneIRU, 
               pathReferenceVerbaleCessioneSUBIRU,
         //      pathReferenceCMT
             ];

           const downloadPromises = [];
           for (const pathRef of filesToDownload) {
             try {
               let blob;

               // Gestione speciale per NT9 con fallback
               if (pathRef === pathReferenceNT9_Primary) {
                 try {
                   blob = await getBlob(pathReferenceNT9_Primary);
                 } catch (ePrimary) {
                   // Se non trova il file nel path primario, prova il fallback
                   blob = await getBlob(pathReferenceNT9_Fallback);
                 }
               } else {
                 blob = await getBlob(pathRef);
               }
                if (blob) {
                  if(pathRef.name==='nt9.zip'){      
                    zipNT9.file(pratica.cui+".zip", blob);
                  }else if( pathRef.name ===pratica.cui+'.pdf'  ){
                    let nomeAllegato:string = pratica.cui+".pdf";
                    zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Verbale_SUBIRU").file(nomeAllegato, blob);
                  }else if( pathRef.name ==="Verbale_Cessione_IRU_" + pratica.codiceInvio + ".pdf.p7m" || pathRef.name ==="Verbale_Cessione_SUBIRU_" + pratica.codiceInvio + ".pdf.p7m"){
                    let nomeVerbale:string = "Verbale_Cessione_SUBIRU_"+pratica.codiceInvio+".pdf.p7m";

                    zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Verbale_SUBIRU").file(nomeVerbale, blob);
                  }else if( pathRef.name ===pratica.codiceRegione+"_F_PSI_03_0.pdf"){
                    zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_PSI_03_0").file(pathRef.name, blob);
                  }else if( pathRef.name ===pratica.codiceRegione+"_F_RET_01_0.pdf"){
                    zip.file(pratica.codiceInvio+"/"+pratica.codiceRegione+"_F_RET_01_0/"+pathRef.name, blob);
                  }else {
                    zip.file(pathRef.name, blob);
                  }
                  
                  downloadPromises.push(Promise.resolve());
              } else {
                this.logger.error(`Errore durante il download di ${pathRef.name}`);
              }
              } catch (error) {
                this.isLoadingResults = false;
                this.logger.info(pathRef.name);
                if(pathRef.name.endsWith(".xlsx")){

                }else{
                  if (error.code === 'storage/object-not-found') {
                    this.logger.error('Il file non esiste:', error.message);
                    this.messageService.add({
                      severity: "info",
                    summary: "Errore" , life:10000,
                      detail: "Il file "+ error.message+" non esiste",
                    });
                  } else {
                    // Gestisci altri tipi di errori
                    this.logger.info('Errore sconosciuto:', error);
                  }
                } 
              }
              
            }

            Promise.all(downloadPromises)
            .then(() => {
              //zip.folder(pratica.nomeInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Altro");
              zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Documentazione_fotografica");
              zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Istanze_Autorizzazioni");
              zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Misure_Collaudo");
              this.googleStorageService.checkIfPraticaHasAltriFile(pratica.cui).subscribe(hasAltriFile =>{
                if(hasAltriFile){
                  this.googleStorageService.getFolderContents(pratica.cui).subscribe({
                    next: (files) => {
                      files.forEach(fileData => {
                        
                        const { blob, fileName } = fileData;
                        const fileNameOriginale = fileName; 

                        zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Altro").file(fileNameOriginale, blob);
                        this.isLoadingResults = false;
                      });
                    },
                    error: (error) => {
                      console.error('Errore durante il download dei file:', error);
                    },
                    complete: () => {

                      zip.generateAsync({ type: 'blob' })
                        .then((blob) => {
                          saveAs(blob, pratica.codiceInvio+'.zip');   
                          this.isLoadingResults = false;                  
                        })
                        .catch(error => console.error('Errore durante la creazione dello zip:', error));
                        this.isLoadingResults = false;
                      zipNT9.generateAsync({ type: 'blob' })
                        .then((blob) => {
                          saveAs(blob, pratica.cui+'.zip'); 
                          this.isLoadingResults = false;
                        })
                        .catch(error => console.error('Errore durante la creazione dello zip:', error));
                        this.isLoadingResults = false;
                    }
                  });
                }else{
                  zip.folder(pratica.codiceInvio+"/"+pratica.cui+"/"+pratica.codiceRegione+"_F_ANN_07_0/Altro");
                  zip.generateAsync({ type: 'blob' })
                  .then((blob) => {
                    saveAs(blob, pratica.codiceInvio+'.zip'); 
                    this.isLoadingResults = false;
                  })
                  .catch(error => console.error('Errore durante la creazione dello zip:', error));
                  zipNT9.generateAsync({ type: 'blob' })
                    .then((blob) => {
                      saveAs(blob, pratica.cui+'.zip'); 
                      this.isLoadingResults = false;
                    })
                    .catch(error => console.error('Errore durante la creazione dello zip:', error));
                  }
                });

            })
            .catch(error => console.error('Errore durante il download dei file:', error));
   }

    async scaricaPacchettoPratica(pratica:PraticaFlowdy2_Firestore){
      if(this.isImpresa){
        this.scaricaPacchettoDaStorage(pratica);

      }else {
        this.confirmationService.confirm({
          message: `Non rinominare i file che si stanno scaricando durante il processo di firma!`,
          header: "ATTENZIONE!",
          icon: "pi pi-exclamation-circle",
          acceptLabel: "PROCEDI",
          acceptButtonStyleClass: "p-button-success",
          rejectLabel: "ANNULLA",
          rejectButtonStyleClass: "p-button-warning",
          accept: async () => {
            this.scaricaPacchettoDaStorage(pratica);          
          },
          reject: () => {
          },
        });
      }
      
     
    }

    consegnaPratica(pratica:PraticaFlowdy2_Firestore){
      this.showDeliverConfirmation = true;
      this.selectedPratica = pratica;
    }

    confermaConsegnaPratica(){
      this.isLoadingResults = true;
      this.praticheService.consegnaFase3(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'FASE 3 della pratica consegnata!', life:5000});
          this.showDeliverConfirmation = false;
          this.selectedPratica = null;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di consegna della FASE 3 della pratica'});
            this.isLoadingResults = false;
            this.showDeliverConfirmation = false;
            this.selectedPratica = null;
        },
        complete: () => {
        }
      });
    }

    apriNoteBocciaturaPresidio(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase1, {
        data: {
          pratica: pratica,
          isBocciaturaPresidio: true
        },
        header: "Note indicate dal presidio per la bocciatura della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }


    openPrendiInCarico(pratica: PraticaFlowdy2_Firestore): void {
      this.confirmationService.confirm({
        message: `Confermi di voler prendere in carico la FASE 3 della pratica ${pratica.cui}?`,
        header: "Presa in carico",
        icon: "pi pi-File-import",
        acceptLabel: "CONFERMA",
        acceptButtonStyleClass: "p-button-success",
        rejectLabel: "ANNULLA",
        rejectButtonStyleClass: "p-button-warning",
        accept: () => {
          this.isLoadingResults = true;
          if(this.isImpresa){
            let utente:Utente = new Utente();
            utente.id = Number(localStorage.getItem("idUtente"));
            this.praticheService.utentePrendeInCaricoFase3(this.selectedPratica.id, utente).subscribe( {
            next: (v) => {
              this.isLoadingResults = false;
              this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
              this.loadPratiche();
            },
            error: (e) => {
                this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                this.isLoadingResults = false;
            },
            complete: () => {
            }
          
          }); 
          }else if(this.isPresidioSF){
            if(pratica.statoFlowdyFase3 === "DA ASSEGNARE" ){
              let utente:Utente = new Utente();
              utente.id = Number(localStorage.getItem("idUtente"));
              this.praticheService.utentePrendeInCaricoFase3(this.selectedPratica.id, utente).subscribe( {
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
                  this.loadPratiche();
                },
                error: (e) => {
                    this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                    this.isLoadingResults = false;
                },
                complete: () => {
                }
              });  
            }else{
              this.praticheService.presidioPrendeInCaricoFase3(this.selectedPratica.id).subscribe( {
                next: (v) => {
                  this.isLoadingResults = false;
                  this.messageService.add({severity:'success', summary:'', detail:'Pratica presa in carico con successo!', life:5000});
                  this.loadPratiche();
                },
                error: (e) => {
                    this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di presa in carico della pratica'});
                    this.isLoadingResults = false;
                },
                complete: () => {
                }
              });  
            }
             
          }
          
        },
        reject: () => {
          //this.msgs = [{severity:'info', summary:'Rejected', detail:'You have rejected'}];
        },
      });
    }

    validaConsegna(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogVerificaConsegnaFase3, {
        data: {
          pratica: pratica,
        },
        header: "Validazione della consegna della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
        width: "80%",
        height: "95%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((consegnaValidata) => {
        if (consegnaValidata && consegnaValidata.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Consegna validata con successo!', life:3000});
          //qui devo chiamare per generare la documentazione
          this.loadPratiche();
        }
      }); 
    }

    apriNoteRework(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase2, {
        data: {
          pratica: pratica,
        },
        header: "Note per il REWORK della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
        width: "60%",
        height: "70%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }
    apriNoteTIMSupport(pratica:PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogNoteReworkFase2, {
        data: {
          pratica: pratica,
          isTIMSupport:true
        },
        header: "Note TIM SUPPORT per la pratica "+ pratica.cui.toUpperCase(),
        width: "50%",
        height: "35%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
    }

    caricaDocumento(pratica: PraticaFlowdy2_Firestore, tipoDocumento :string) {
      let header = "Caricamento del Verbale di ";
      if(tipoDocumento==='CONSEGNA'){
        header+="CONSEGNA ";
      }else{
        header+="ATTIVAZIONE ";
      }
      header+=" della pratica "+ pratica.cui.toUpperCase();

      this.ref = this.dialogService.open(DialogCaricaPacchettoNT9, {
        data: {
          pratica: pratica,
          tipoDoc:tipoDocumento,
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((caricamentoDoc) => {
        if (caricamentoDoc && caricamentoDoc.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Verbale di '+ tipoDocumento+' caricato con successo!', life:3000});
        }
      }); 
      
    }

    caricaPermesso(pratica: PraticaFlowdy2_Firestore) {
      let header = "Caricamento del PERMESSO ENTE PUBBLICO ";
      header+=" per la pratica "+ pratica.cui.toUpperCase();

      this.ref = this.dialogService.open(DialogCaricaPermessoFase2, {
        data: {
          pratica: pratica,
        },
        header: header,
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((caricamentoDoc) => {
        if (caricamentoDoc && caricamentoDoc.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Permesso ente pubblico per la pratica '+ pratica.cui+' caricato con successo!', life:3000});
        }
      }); 
      
    }

    caricaFotoCPE(pratica: PraticaFlowdy2_Firestore){
      this.ref = this.dialogService.open(DialogCaricaFoto, {
        data: {
          pratica: pratica,
        },
        header: "Caricamento FOTO del CPE della pratica "+pratica.cui.toUpperCase(),
        width: "50%",
        height: "50%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((caricamentoFotoCPE) => {
        if (caricamentoFotoCPE && caricamentoFotoCPE.success) {
          this.messageService.add({severity:'success', summary:'', detail: 'Foto del cpe caricata con successo!', life:3000});
        }
      }); 
    }

    async scaricaFotoCPE(pratica: PraticaFlowdy2_Firestore, isMassivo:boolean) {
      const storage = getStorage();
      this.isLoadingResults= true;
      const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/foto/`;
      try {
        const folderRef= ref(storage, folderPath);

        const fileList = await listAll(folderRef);
        const fileNames = fileList.items.map(item => item.name); // Ottieni solo i nomi dei file
        for (const fileRef of fileNames) {
         
          const filePath = folderPath+"/"+fileRef;
          const fileReference = ref(storage, filePath);
          const blobFile = await getBlob(fileReference);
          saveAs(blobFile,fileRef);

      
        }
        if(!isMassivo){
          this.messageService.add({severity:'success', summary:'', detail:pratica.numeroFotoCPEUploaded + ' file scaricati con successo!', life:3000});
        }

        this.isLoadingResults= false;
      } catch (error) {
        this.isLoadingResults= false;
        this.messageService.add({
          severity: "info",
          summary: "Attenzione!",
          detail: "Errore nel download dei file",
        });
      } 
    }

    caricaFile(pratica: PraticaFlowdy2_Firestore, tipoFile :string) {
      let header = "Caricamento ";
      if(tipoFile==='NT9'){
        header+="del pacchetto NT9";
      }else if(tipoFile==='FOTO ROUTER'){
        header+="della foto del ROUTER";
      }else if(tipoFile==='VERBALE WIFI'){
        header+="del VERBALE WIFI";
      }else{
        header+="ALTRI file";
      }

      //
      header+=" della pratica "+ pratica.cui.toUpperCase();
      if(tipoFile==='NT9'){
        this.ref = this.dialogService.open(DialogCaricaPacchettoNT9, {
          data: {
            pratica: pratica,
            tipoFile:tipoFile,
          },
          header: header,
          width: "50%",
          height: "50%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
  
      }else if(tipoFile==='FOTO ROUTER'){
        this.ref = this.dialogService.open(DialogCaricaFoto, {
          data: {
            pratica: pratica,
            tipoFile:'FOTO ROUTER'
          },
          header:header,
          width: "50%",
          height: "50%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      }else if(tipoFile==='VERBALE WIFI'){
        this.ref = this.dialogService.open(DialogCaricaVerbaleWifiFase3, {
          data: {
            pratica: pratica,
            tipoFile:tipoFile,
          },
          header:header,
          width: "50%",
          height: "50%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      }else{
        this.ref = this.dialogService.open(DialogCaricaAltriFile, {
          data: {
            pratica: pratica,
            tipoFile:tipoFile,
          },
          header: header,
          width: "50%",
          height: "50%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
      }
     
      this.ref.onClose.subscribe((caricamentoDoc) => {
        if (caricamentoDoc && caricamentoDoc.success) {
          if(caricamentoDoc.totalFiles){
            if(caricamentoDoc.totalFiles==1){
              this.messageService.add({severity:'success', summary:'', detail: '1 file caricato con successo!', life:3000});
            }else{
              this.messageService.add({severity:'success', summary:'', detail: caricamentoDoc.totalFiles +' file caricati con successo!', life:3000});
            }
          }else{
            this.messageService.add({severity:'success', summary:'', detail: tipoFile+' caricata con successo!', life:3000});
          }
          
        }
      }); 
    }

    async scaricaNT9FromFE(pratica:PraticaFlowdy2_Firestore) {
      const storage = getStorage();
      this.isLoadingResults = true;
        const pathReferenceNT9 = ref(
          storage,
          "pratiche/scuola/" +
          pratica.cui +
            "/IN/FASE_3/file/nt9.zip"
        );
  
        const blobNT9 = await getBlob(pathReferenceNT9);
        saveAs(blobNT9, "nt9.zip");
        this.isLoadingResults = false;
    }
    async scaricaFotoRouter(pratica:PraticaFlowdy2_Firestore) {

        this.isLoadingResults = true;
        const storage = getStorage();
        const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/foto/`;
        try {
          const folderRef= ref(storage, folderPath);

          const fileList = await listAll(folderRef);
          const fileNames = fileList.items.map(item => item.name); // Ottieni solo i nomi dei file
          for (const fileRef of fileNames) {
          
            const filePath = folderPath+"/"+fileRef;
            const fileReference = ref(storage, filePath);
            const blobFile = await getBlob(fileReference);
            saveAs(blobFile,fileRef);

        
          }
        

          this.isLoadingResults= false;
        } catch (error) {
          this.isLoadingResults= false;
          this.messageService.add({
            severity: "info",
            summary: "Attenzione!",
            detail: "Errore nel download dei file",
          });
        } 
        
      }

    showPacchettoNT9Uploaded(pratica:PraticaFlowdy2_Firestore):boolean{
        if((this.isImpresa || this.isPresidioSF) 
          //&& pratica.stato==='IN PROGETTAZIONE' 
          && (pratica.statoFlowdyFase3==='IN PROGETTAZIONE' || pratica.statoFlowdyFase3==='CONSEGNATA' || pratica.statoFlowdyFase3==='IN VERIFICA SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK AZIENDA'  || pratica.statoFlowdyFase3==='IN CARICO PRESIDIO') 
          &&  pratica.nt9Uploaded){
          return true;
        }
        return false;
      }
      showFotoRouterUploaded(pratica:PraticaFlowdy2_Firestore):boolean{
        if((this.isImpresa || this.isPresidioSF) 
          && (pratica.statoFlowdyFase3==='IN PROGETTAZIONE' || pratica.statoFlowdyFase3==='CONSEGNATA' || pratica.statoFlowdyFase3==='IN VERIFICA SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK SMARTFIBER' || pratica.statoFlowdyFase3==='IN REWORK AZIENDA'  || pratica.statoFlowdyFase3==='IN CARICO PRESIDIO')       
          && pratica.fotoRouterUploaded){
          return true;
        }
        return false;
      }

    chiediEliminazioneTuttiFileCaricati(pratica: PraticaFlowdy2_Firestore, tipoFile: string) {
      this.selectedPratica = pratica;
      if (tipoFile === 'ALTRO') {
        this.showEliminaFileALTROConfirmation = true;
      } else if (tipoFile === 'NT9') {
        this.showEliminaFileNT9Confirmation = true;
      } else if (tipoFile === 'FOTO ROUTER') {
        this.showEliminaFileFotoRouterConfirmation = true;
      } else if (tipoFile === 'VERBALE WIFI') {
        this.showEliminaFileVerbaleWifiConfirmation = true;
      }
    }
    
    async eliminataTuttiFileCaricati(pratica: PraticaFlowdy2_Firestore, tipoFile: string) {
      const storage = getStorage();
      this.isLoadingResults = true;
      let folderPath = '';
      if(tipoFile === 'NT9'){
       // this.showEliminaFileNT9Confirmation = true;
        folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/file/`;
      }else if(tipoFile === 'FOTO ROUTER'){
       // this.showEliminaFileFotoRouterConfirmation = true;
        folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/foto/`;
      }else if(tipoFile === 'VERBALE WIFI'){
        folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/VERBALE_WIFI_${pratica.cui}.pdf`;
        this.logger.info("ELIMINAZIONE VERBALE WIFI @ "+ folderPath);

      }else{
        //this.showEliminaFileALTROConfirmation = true;
        folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_3/altro/`;
      }
      
    
      try {
        const folderRef = ref(storage, folderPath);
        const fileList = await listAll(folderRef);
        const deletePromises = [];
        let deletedFileCount = 0;
    
        for (const fileItem of fileList.items) { 
          this.logger.info("ELIMINAZIONE FILE: "+fileItem.name);
              deletePromises.push(deleteObject(fileItem).then(() => {
                deletedFileCount++;
              }).catch((deleteError) => {
                this.messageService.add({
                  severity: "error",
                  summary: "Errore",
                  detail: `Errore durante l'eliminazione del file ${fileItem.name}: ${deleteError.message}`,
                  life: 10000,
                });
              }));
       
          }
    
        // Aspetta che tutti i file siano cancellati
        await Promise.all(deletePromises);
    
        // Aggiorna il documento Firestore solo dopo la cancellazione dei file
        const docRef = this.firestore.collection(this.collection_pratiche).doc(pratica.cui);
        pratica.fileAltriUploadedFase3 = false;
        
        await docRef.update(pratica);
        this.selectedPratica = null;
        if(tipoFile === 'NT9'){
          pratica.nt9Uploaded = false;
        }else if(tipoFile === 'FOTO ROUTER'){
          pratica.fotoRouterUploaded = false;
        }else if(tipoFile === 'VERBALE WIFI'){
          pratica.verbaleWifiUploaded = false;
        }else{
          pratica.fileAltriUploadedFase3 = false;
        }
        await docRef.update(pratica);
        // Mostra un messaggio con il numero di file eliminati e il tipo
        this.messageService.add({
          severity: "success",
          summary: "Eliminazione completata",
          detail: `${deletedFileCount} file sono stati eliminati con successo.`,
          life: 10000,
        });
    
        this.isLoadingResults = false;
        if(tipoFile === 'NT9'){
          this.showEliminaFileNT9Confirmation = false;
        }else if(tipoFile === 'FOTO ROUTER'){
          this.showEliminaFileFotoRouterConfirmation = false;
        }else{
          this.showEliminaFileALTROConfirmation = false;
        }

      } catch (error) {
        this.isLoadingResults = false;
        this.messageService.add({
          severity: "error",
          summary: "Attenzione!",
          detail: `Errore nel recupero dei file: ${error.message}`,
        });
      }
    }

    
    async scaricaFile(pratica: PraticaFlowdy2_Firestore, tipoFile :string, isMassivo:boolean) {
      const storage = getStorage();
      this.isLoadingResults= true;
      const folderPath = `pratiche/scuola/${pratica.cui}/IN/FASE_2/file/`;
      try {
        const folderRef= ref(storage, folderPath);

        const fileList = await listAll(folderRef);
        const fileNames = fileList.items.map(item => item.name); // Ottieni solo i nomi dei file
        for (const fileRef of fileNames) {
         
         if(fileRef.startsWith(tipoFile)){
          const filePath = folderPath+"/"+fileRef;
          const fileReference = ref(storage, filePath);
          const blobFile = await getBlob(fileReference);
          saveAs(blobFile,fileRef);

         }
        }
        const numeroFile:number = tipoFile==='PING_TEST'? pratica.numeroFilePingtestUploaded : pratica.numeroFileSpeedtestUploaded;
        if(!isMassivo){
          this.messageService.add({severity:'success', summary:'', detail:numeroFile + ' file scaricati con successo!', life:3000});

        }

        this.isLoadingResults= false;
      } catch (error) {
        this.isLoadingResults= false;
        this.messageService.add({
          severity: "info",
          summary: "Attenzione!",
          detail: "Errore nel download dei file",
        });
      } 
    }

    annullaConsegna(pratica:PraticaFlowdy2_Firestore){
      this.showAnnullaConsegnaConfirmation = true;
      this.selectedPratica = pratica;
    }
    confermaAnnullamentoConsegnaPratica(){
      this.isLoadingResults = true;
      this.praticheService.annullaConsegnaFase3(this.selectedPratica.id).subscribe( {
        next: (v) => {
          this.isLoadingResults = false;
          this.messageService.add({severity:'success', summary:'', detail:'Annullamento consegna FASE 3 avvenuto con successo!', life:5000});
          this.showAnnullaConsegnaConfirmation = false;
          this.selectedPratica = null;
          this.isLoadingResults = false;
          this.loadPratiche();
        },
        error: (e) => {
            this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di annullamento della consegna della FASE 3 della pratica'});
            this.isLoadingResults = false;
            this.showAnnullaConsegnaConfirmation = false;
            this.selectedPratica = null;
            this.isLoadingResults = false;
        },
        complete: () => {
         }
      });
    }

    async scaricaPermesso(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      const storage = getStorage();
      let fileName = "pratiche/scuola/" +  pratica.cui + "/IN/FASE_2/permesso/permesso_FASE2.pdf";
      let pathReferenceDoc = ref(
        storage,
        fileName
      );
      const blobFile = await getBlob(pathReferenceDoc);
      saveAs(blobFile,pratica.cui+"_permesso_fase2.pdf");
      this.isLoadingResults = false;
    }

    async scaricaDoc(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      const storage = getStorage();
      let fileName = "pratiche/scuola/" +  pratica.cui + "/IN/FASE_2/documentazione/"+pratica.cui;
      fileName+= "_VERBALE_ATTIVAZIONE_FASE2.pdf";
      let pathReferenceDoc = ref(storage,fileName );
      const blobFile = await getBlob(pathReferenceDoc);
      saveAs(blobFile,pratica.cui+"_VERBALE_ATTIVAZIONE_FASE2.pdf");
      this.isLoadingResults = false;
    }

    async scaricaTuttaDocumentazione(pratica: PraticaFlowdy2_Firestore) {
      this.isLoadingResults = true;
      const storage = getStorage();
      if(pratica.filePingTestUploaded){
        this.scaricaFile(pratica,'PING_TEST', true);
      }
      if(pratica.fileSpeedTestUploaded){
        this.scaricaFile(pratica,'SPEED_TEST', true);
      }
      if(pratica.fotoCPEUploaded){
        this.scaricaFotoCPE(pratica, true);
      }
      if(pratica.fileVerbaleAttivazioneUploaded){
        this.scaricaDoc(pratica);
      }

      if(pratica.servePermessoEntePubblico && pratica.permessoUploaded){
        this.scaricaPermesso(pratica);
      }

      this.isLoadingResults = false;
    }

    importaInformazioni(){
      this.importID = uuidv4();
      this.csvbox_importer_comunicaInfoFase3.setUser({
          importID: this.importID,
        });
      this.csvbox_importer_comunicaInfoFase3.openModal();
    }
    importaEsitiConsegna(){
      this.importID = uuidv4();
      this.csvbox_importer_comunicaEsitiConsegnaFase3.setUser({
          importID: this.importID,
        });
      this.csvbox_importer_comunicaEsitiConsegnaFase3.openModal();
    }
    

    comunicaEsitoFase1(pratica:PraticaFlowdy2_Firestore, isApprovata:boolean){
      if(isApprovata){
        this.ref = this.dialogService.open(DialogAccettazioneInvioInfratel, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Accettazione della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
          width: "60%",
          height: "60%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((bocciaturaFase1) => {
          if (bocciaturaFase1 && bocciaturaFase1.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Accettazione della FASE 3 della pratica comuinicata!', life:3000});
          }
        }); 
      }else{
        this.ref = this.dialogService.open(ComunicaBocciatura, {
          data: {
            pratica: pratica,
            fase:1
          },
          header: "Indica le moditivazioni della bocciatura della FASE 3 della pratica "+ pratica.cui.toUpperCase(),
          width: "60%",
          height: "70%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((bocciaturaFase1) => {
          if (bocciaturaFase1 && bocciaturaFase1.success) {
            this.messageService.add({severity:'success', summary:'', detail:'Bocciatura della FASE 3 della pratica comuinicata!', life:3000});
          }
        }); 
      }
     
    }
    openStoricoPratica(pratica: PraticaFlowdy2_Firestore) {
       this.isLoadingResults = true;
       this.praticheService.getStoricoFase3(pratica.id).subscribe(storicoPratica=>{
        this.isLoadingResults = false;
          if(storicoPratica && storicoPratica.length > 0){
            this.ref = this.dialogService.open(StoricoPraticaComponent, {
              data: {
                pratica: pratica,
                storicoPratica: storicoPratica,
                fase:3
              },
              header: "Storico della FASE 3 della pratica "+pratica.cui,
              width: "50%",
              height: "85%",
              baseZIndex: 10000,
              closable: true,
              draggable: false,
            });
          }else{
            this.messageService.add({
              severity: "info",
              summary: "Attenzione!",
              detail: "La pratica non presenta STORICO",
            });
          }
      }); 
    }

    goBack(){
      this.logger.info("[PRATICHE FASE 3] GO BACK FROM: "+ this.paginaBack);
      /* let from = 'WIP_APPUNTAMENTI';
      if(this.filtroStatoFlowdy){
        from = 'DOCS_FASE3';
      } */
      // Naviga verso la home con i parametri per selezionare il tab corretto
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=> this.router.navigate([''],
        {
          queryParams: { 
            'bando': '1', // Bando 1
            'from': this.paginaBack
          }, 
            queryParamsHandling: 'merge',
        }
      ));
     this.removeFilter();
     }


    comunicaDataAppuntamento(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogComunicaDataAppuntamentoFase2, {
        data: {
          pratica: pratica,
        },
        header: "Comunica data dell'appuntamento per la pratica "+pratica.cui,
        width: "50%",
        height: "30%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((dataAppuntamento) => {
        if (dataAppuntamento && dataAppuntamento.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Data appuntamento comunicata con successo!', life:3000});
          this.loadPratiche();
        }
      }); 
    }
    comunicaEsitoAppuntamento(pratica: PraticaFlowdy2_Firestore) {
      this.ref = this.dialogService.open(DialogComunicaEsitoAppuntamentoFase2, {
        data: {
          pratica: pratica,
        },
        header: "Comunica l'esito dell'installazione del router per la pratica "+pratica.cui,
        width: "70%",
        height: "85%",
        baseZIndex: 10000,
        closable: true,
        draggable: false,
      });
      this.ref.onClose.subscribe((esitoInstallazione) => {
        if (esitoInstallazione && esitoInstallazione.success) {
          this.messageService.add({severity:'success', summary:'', detail:'Esito installazione router comunicata con successo!', life:3000});
          this.loadPratiche();
        }
      });
    }

    checkIfDeliverable(pratica: PraticaFlowdy2_Firestore):boolean{
      if( 
         ( pratica.statoFlowdyFase2 === 'INSTALLAZIONE EFFETTUATA' || pratica.statoFlowdyFase2 === 'IN REWORK AZIENDA')  && 
        pratica.fotoCPEUploaded &&
        pratica.fileVerbaleAttivazioneUploaded &&
        pratica.filePingTestUploaded && pratica.numeroFilePingtestUploaded > 0 &&
        pratica.fileSpeedTestUploaded && pratica.numeroFileSpeedtestUploaded > 0 
      
      )
      {
        return true;
      }
     
      return false;
    }

  

   
    loadPratiche(){
        this.isLoadingResults = false;
        const collectionRef = this.firestore.collection(this.collection_pratiche).ref;
        let query;
      if(this.isPresidioTIM){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 FILTRO PER LOTTO "+ this.filtroLotto);
            query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("statoFlowdyFase3", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase2");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .where("lotto", "==", this.filtroLottoPerFase)
              .where("statoFlowdyFase3", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase2");

            }else {
              this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
            //  .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            //  .where("statoFlowdyFase1", "==", "PUBBLICATA")
             // .where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase3");

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            //.where("codiceStatoInfratelFase1", "!=", "1-6")
            //.where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase3");
          }else  if(this.filtroOda){
            this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("codiceStatoInfratelFase1", "==", '1-6')
              .where("numeroOda", "==", Number(this.filtroOda))
            //  .where("importoPagatoFase1", "==", null)
             // .where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase3");
            }else{
              query= collectionRef.where("bando", "==", "BANDO 2").where("numeroOda", "==", Number(this.filtroOda)).orderBy("codiceStatoInfratelFase2");
            }
           
          }
          
        }else{
          this.logger.info("[FASE 3 BANDO 1] PRESIDIO TIM LOADING FASE 3 BANDO 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("codiceStatoInfratelFase1", "!=", "1-6")
           //   .where("statoFlowdyFase2", "==", "IN CARICO PRESIDIO")
              .orderBy("codiceStatoInfratelFase3");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            //.where("statoFlowdyFase1", "==", "IN CARICO PRESIDIO")
            .orderBy("codiceStatoInfratelFase3");
          }
        }
      }else if(this.isImpresa){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .orderBy("codiceStatoInfratelFase3")
            .orderBy("cui");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("lotto", "==", this.filtroLottoPerFase)
              .orderBy("cui");

            }else {
              this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
              .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
              .orderBy("cui");

            }
          }else  if(this.filtroInLavorazione){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER IN LAVORAZIONE ");

            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase2")
            .orderBy("cui");
          }else  if(this.filtroOda){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("importoPagatoFase1", "==", null)
              .orderBy("codiceStatoInfratelFase2");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
              .where("numeroOda", "==", Number(this.filtroOda))
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .orderBy("codiceStatoInfratelFase2");
            }
           
          }else if(this.filtroPratica){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE FASE 2 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("cui", "==", this.filtroPratica);
          }else if(this.filtroStatoFlowdy){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 FILTRO PER STATO FLOWDY "+ this.filtroStatoFlowdy);
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
            .orderBy("codiceStatoInfratelFase3");
          }else{
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 SENZA FILTRI");
            this.mostraPraticheCompletate = true;
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .orderBy("codiceStatoInfratelFase3");
          }
          
        }else{
          this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE PER AZIENDA FASE 3 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
              .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("codiceStatoInfratelFase3", "!=", "3-6")
              .orderBy("codiceStatoInfratelFase3");
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .orderBy("codiceStatoInfratelFase3");
          }
        }
      }else if(this.isPresidioSF || this.isAdmin || this.isSuperAdmin || this.isDirigenteFirmaPacchetti || this.isDemo){
        if(this.filterIsSet){
          if(this.filtroLotto){
            this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 FILTRO PER LOTTO "+ this.filtroLotto);
           query= collectionRef.where("bando", "==", "BANDO 1")
            .where("lotto", "==", this.filtroLotto)
            .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
            .where("codiceStatoInfratelFase3", "!=", "3-6")
            .orderBy("codiceStatoInfratelFase3");
          }else if(this.filtroStatoInfratel){
            if(this.filtroLottoPerFase){
              this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel + " E LOTTO "+ this.filtroLottoPerFase);

              query= collectionRef
                .where("bando", "==", "BANDO 1")
                .where("codiceStatoInfratelFase1", "==", "1-6")
                .where("codiceStatoInfratelFase2", "==", "2-6")
                .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
                .where("lotto", "==", this.filtroLottoPerFase)
                .orderBy("codiceStatoInfratelFase3");

            }else {
              this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 FILTRO PER STATO INFRATEL "+ this.filtroStatoInfratel);

              query= collectionRef
                .where("bando", "==", "BANDO 1")
                .where("codiceStatoInfratelFase1", "==", "1-6")
                .where("codiceStatoInfratelFase2", "==", "2-6")
                .where("codiceStatoInfratelFase3", "==", this.filtroStatoInfratel)
                .orderBy("codiceStatoInfratelFase3");

            }
          }else if(this.filtroInLavorazione){
            this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 FILTRO PER IN LAVORAZIONE ");
            query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
                .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "!=", "3-6")
              .orderBy("codiceStatoInfratelFase3");
          }else  if(this.filtroOda){
            this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 FILTRO PER ODA "+ this.filtroOda);
            if(this.filtroDaPagare){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
                .where("codiceStatoInfratelFase2", "==", "2-6")
             // .where("numeroOdaFase3", "==", Number(this.filtroOda))
              .where("importoPagatoFase3", "==", null)
              .orderBy("codiceStatoInfratelFase3");
            }else{
              query= collectionRef
              .where("bando", "==", "BANDO 1")
             // .where("codiceStatoInfratelFase1", "==", "1-6")
            //  .where("numeroOdaFase3", "==", Number(this.filtroOda))
              .orderBy("codiceStatoInfratelFase3");
            }
           
          }else if(this.filtroPratica){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE FASE 2 FILTRO PER PRATICA "+ this.filtroPratica );
            query= collectionRef
          //  .where("idAziendaFase3", "==", this.userService.getUser().azienda.id)
            .where("cui", "==", this.filtroPratica);
          }else if(this.filtroImpresa){
            if(this.filtroStatoFlowdy){
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("idAziendaFase3", "==",  Number(this.filtroImpresa))
              .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
              .orderBy("codiceStatoInfratelFase3");

            }else{
              this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE FASE 2 FILTRO PER IMPRESA "+ this.filtroImpresa  );

              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("idAziendaFase3", "==",  Number(this.filtroImpresa))
              .orderBy("codiceStatoInfratelFase3");
            }
          }else if(this.filtroStatoFlowdy){
            if(this.filtroRegione){
            this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE FASE 3 FILTRO PER STATO FLOWDY "+ this.filtroStatoFlowdy + " E REGIONE "+ this.filtroRegione );
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            .where("codiceStatoInfratelFase1", "==", "1-6")
            .where("codiceStatoInfratelFase2", "==", '2-6')
            .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
            .where("regione", "==", this.filtroRegione)
            .orderBy("codiceStatoInfratelFase3");
            }else{
              this.logger.info("[FASE 3 BANDO 1] LOADING PRATICHE FASE 3 FILTRO PER STATO FLOWDY "+ this.filtroStatoFlowdy );
              query= collectionRef
              .where("bando", "==", "BANDO 1")
              .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", '2-6')
              .where("statoFlowdyFase3", "==", this.filtroStatoFlowdy)
              .orderBy("codiceStatoInfratelFase3");
            }
          }
          
        }else{
          this.logger.info("[FASE 3 BANDO 1] LOADING FASE 3 BANDO 1 SENZA FILTRI");

          if(!this.mostraPraticheCompletate){
             query = collectionRef
              .where("bando", "==", "BANDO 1")
            //  .where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
              .where("codiceStatoInfratelFase3", "!=", "3-6")
             .orderBy("codiceStatoInfratelFase3")
             ;
            
          }else{
            query= collectionRef
            .where("bando", "==", "BANDO 1")
            //.where("codiceStatoInfratelFase1", "==", "1-6")
              .where("codiceStatoInfratelFase2", "==", "2-6")
            .orderBy("codiceStatoInfratelFase3");
          }
        }
      }

        
        
        onSnapshot(query, (qs) => {
          this.logger.info("[FASE 3 BANDO 1] FASE 3 BANDO 1 CARICATE "+ qs.docs.length);

          this.pratiche = [];
          this.praticheFiltrate = [];
          
          qs.forEach((doc) => {
            let pratica = doc.data() as PraticaFlowdy2_Firestore;
            
            if(this.isPresidioTIM){
              if(this.filtroStatoInfratel){
                if(pratica.codiceStatoInfratelFase3 === this.filtroStatoInfratel){
  
                  this.pratiche.push(pratica);
                  this.praticheFiltrate.push(pratica);
                }
              }else{
                if(!this.mostraPraticheCompletate){
                  if(pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' ){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }else{
                  if(pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' || pratica.codiceStatoInfratelFase3 === '3-6'){
    
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }
                
              }
              

            }else{

               if(pratica.statoFlowdyFase1!=='SOPRALLUOGO KO'  && pratica.codiceStatoInfratelFase2==='2-6'){
                if(this.filtroStatoInfratel){
                  if(this.filtroStatoInfratel!== '3-6'){
                    if(!this.mostraPraticheCompletate){
                      if(pratica.codiceStatoInfratelFase2 ==='2-6' && pratica.codiceStatoInfratelFase3 !== '3-6' ){
        
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      }
                    }else{
                      if(pratica.codiceStatoInfratelFase2 ==='2-6' && (
                        pratica.codiceStatoInfratelFase3 === '3-1' || pratica.codiceStatoInfratelFase3 === '3-2' ||pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' || pratica.codiceStatoInfratelFase3 === '3-6'
                      )){
        
                        this.pratiche.push(pratica);
                        this.praticheFiltrate.push(pratica);
                      }
                    }
                  }else{
                    if( pratica.codiceStatoInfratelFase2 ==='2-6' && pratica.codiceStatoInfratelFase3 === '3-6'){
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                  
                 
                }else if(this.filtroStatoFlowdy){
                  if(pratica.statoFlowdyFase3 === this.filtroStatoFlowdy){
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  }
                }else if(this.filterIsSet && this.filtroOda){
                  if((pratica.numeroOdaFase3 && pratica.numeroOdaFase3 === Number(this.filtroOda) || 
                  ( !pratica.numeroOdaFase3 && pratica.numeroOda === Number(this.filtroOda)))){
                    this.pratiche.push(pratica);
                    this.praticheFiltrate.push(pratica);
                  } 
              }else {
                  if(!this.mostraPraticheCompletate){
                    if(pratica.codiceStatoInfratelFase2 ==='2-6' && pratica.codiceStatoInfratelFase3 !== '3-6' ){
      
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }else{
                    if(pratica.codiceStatoInfratelFase2 ==='2-6' && (
                      pratica.codiceStatoInfratelFase3 === '3-1' || pratica.codiceStatoInfratelFase3 === '3-2' ||pratica.codiceStatoInfratelFase3 === '3-3' || pratica.codiceStatoInfratelFase3 === '3-4' || pratica.codiceStatoInfratelFase3 === '3-6'
                    )){
      
                      this.pratiche.push(pratica);
                      this.praticheFiltrate.push(pratica);
                    }
                  }
                 }
                }
                
              
              
            }
           

          });
          this.filtraPratiche(null);
          this.isLoadingResults = false;
        });
  
    }

    onMostraCompletatiChange(newValue: boolean): void {
      this.mostraPraticheCompletate = newValue
      this.loadPratiche();
    }

    checkInviataAdInfratel(pratica:PraticaFlowdy2_Firestore):boolean{
      if(pratica.codiceStatoInfratelFase3==='3-5' || pratica.codiceStatoInfratelFase3==='3-6'){
        return true;
      }
      return false;
    }

    filtraPratiche(event: any){
     
      if(event && event.target){
        
        this.praticheDT.filterGlobal(event.target.value, 'contains');
      }else {
       
        if(this._filtroPratiche && Object.keys(this._filtroPratiche).length !== 0){

          this.filterTabellaIsSet = true;
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              ((this._filtroPratiche.tipo?.length ?? 0 ) > 0  && (this._filtroPratiche.tipo.indexOf(pratica.tipoSede) == -1 || this._filtroPratiche.tipo.indexOf(pratica.tipoSedeEffettiva) == -1)) ||
              ((this._filtroPratiche.statoInfratel?.length ?? 0  > 0 ) &&  this._filtroPratiche.statoInfratel.indexOf(pratica.codiceStatoInfratelFase3) == -1  )   ||
              ((this._filtroPratiche.statoPratica?.length ?? 0  > 0 ) &&  this._filtroPratiche.statoPratica.indexOf(pratica.statoFlowdyFase3) == -1  )  ||
              ((this._filtroPratiche.regione?.length ?? 0  > 0 ) &&  this._filtroPratiche.regione.indexOf(pratica.regione) == -1  )  ||
              ((this._filtroPratiche.impresa?.length ?? 0  > 0 ) &&  this._filtroPratiche.impresa.indexOf(pratica.idAziendaFase3) == -1  )  

            ){
              return false;
            }
            
            return true;

          });
        }else{
          this.praticheFiltrate = this.pratiche;
        }
      }
    }

    filtraPerStatoInfratel(statoInfratel:string){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(statoInfratel, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
    }

    filtraPerOda(numeroOda:number){
      
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(numeroOda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
      
    }

    filtraPerBando(oda:OdaAtFirestore){
      if(!this.filterTabellaIsSet){
        this.praticheDT.filterGlobal(oda.bando, 'contains');
        this.filterTabellaIsSet = true;
      }else{
        this.praticheDT.clear();
        this.filterTabellaIsSet = false;
      }
      

      
    }
    filtraPerAzienda(azienda:String){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheDT.filterGlobal(azienda, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
     }

    filtraPerLotto(lotto:string){
      if(!this.filterTabellaIsSet){
        if(
          (!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) 
        ){
          this.praticheFiltrate = this.pratiche.filter((pratica: PraticaFlowdy2_Firestore) => {
            if(
              pratica.lotto === lotto

            ){
              return true;
            }
            
            return false;

          });
          //this.praticheDT.filterGlobal(lotto, 'contains');
          this.filterTabellaIsSet = true;
        }
      }else{
        this.praticheDT.clear();
        if((!this._filtroPratiche.tipo || !this._filtroPratiche.tipo.length) && 
          (!this._filtroPratiche.statoInfratel || !this._filtroPratiche.statoInfratel.length) &&
          (!this._filtroPratiche.regione || !this._filtroPratiche.regione.length) &&
          (!this._filtroPratiche.statoPratica || !this._filtroPratiche.statoPratica.length) ){
            this.filterTabellaIsSet = false;
        }
      }
    
      
    }
    removeFilter(){
      
      if(this.filtroLotto || this.filtroStatoInfratel || this.filtroInLavorazione || this.filtroOda || this.filtroLottoPerFase || this.filtroPratica || this.filtroStatoFlowdy || this.filtroImpresa){
        this.location.replaceState('/pratiche-bando1/fase-3');
        
        this.filterIsSet = false;
        this.filtroLotto = null;
        this.filtroStatoInfratel = null;
        this.filtroInLavorazione = null;
        this.filtroOda = null;
        this.filtroLottoPerFase = null;
        this.filtroPratica = null;
        this.filtroStatoFlowdy = null;
        this.filtroImpresa = null;
        this.mostraPraticheCompletate = false;
        this.loadPratiche();
      }else{
        if(this._filtroPratiche && 
          (this._filtroPratiche.tipo && this._filtroPratiche.tipo.length > 0) || 
          (this._filtroPratiche.statoInfratel && this._filtroPratiche.statoInfratel.length > 0 ) ||
          (this._filtroPratiche.regione && this._filtroPratiche.regione.length > 0 ) ||
          (this._filtroPratiche.statoPratica && this._filtroPratiche.statoPratica.length > 0 ) ||
          (this._filtroPratiche.impresa && this._filtroPratiche.impresa.length > 0 )
        ){
          this._filtroPratiche.tipo           = [];
          this._filtroPratiche.statoInfratel  = [];
          this._filtroPratiche.statoPratica   = [];
          this._filtroPratiche.regione   = [];
          this._filtroPratiche.impresa   = [];
        
        }
        this.filterTabellaIsSet = false;
        this.praticheFiltrate = this.pratiche;
        this.praticheDT.clear();
      }
     
     
    }

    mostraPratiche(oda:OdaAtFirestore, fase:string){

    }

    scaricaReportPratiche(){
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, '0')}_${(today.getMonth() + 1).toString().padStart(2, '0')}_${today.getFullYear()}`;
     this.excelService.exportPraticheFase3ToExcel(this.pratiche, `pratiche_bando1_fase3_${formattedDate}.xlsx`, this.isImpresa);

    }

    exportPraticheRespinteFase3() {
      const today = new Date();
      const formattedDate = `${today.getDate().toString().padStart(2, "0")}_${(today.getMonth() + 1).toString().padStart(2, "0")}_${today.getFullYear()}`;
      this.excelService.exportPraticheRespinteFase3ToExcel(
        this.pratiche,
        `pratiche_respinte_bando1_fase3_${formattedDate}.xlsx`,
      );
      const count = this.pratiche.filter(
        (p) => p.statoFlowdyFase3 === "RESPINTA",
      ).length;
      this.messageService.add({
        severity: "success",
        summary: "Export completato",
        detail: `Esportate ${count} pratiche con stato RESPINTA`,
        life: 3000,
      });
    }

    

    setUserRole(){
      if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "ADMIN"
      ) {
        this.isAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SUPERADMIN"
      ) {
        this.isSuperAdmin = true;
      } else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "SMARTFIBER"
      ) {
        this.isPresidioSF = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PRESIDIO"
      ) {
        this.isPresidioTIM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "OPERATORE_AZIENDA"
      ) {
        this.isImpresa = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_VERBALI"
      ) {
        this.isDirigenteFirmaVerbali = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DIRIGENTE_FIRMA_PACCHETTI"
      ) {
        this.isDirigenteFirmaPacchetti = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "PM"
      ) {
        this.isPM = true;
      }else if (
        localStorage.getItem("ruolo") &&
        localStorage.getItem("ruolo") === "DEMO"
      ) {
        this.isDemo = true;
      }
    }
  
  }
